{
  "about.blocks": "Serveurs modérés",
  "about.contact": "Contact :",
  "about.default_locale": "Défaut",
  "about.disclaimer": "Mastodon est un logiciel libre, open-source et une marque déposée de Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Raison non disponible",
  "about.domain_blocks.preamble": "Mastodon vous permet généralement de visualiser le contenu et d'interagir avec les utilisateurs et utilisatrices de n'importe quel autre serveur dans le fédivers. Voici les exceptions qui ont été faites sur ce serveur.",
  "about.domain_blocks.silenced.explanation": "Vous ne verrez généralement pas les profils et le contenu de ce serveur, à moins que vous ne les recherchiez explicitement ou que vous ne choisissiez de les suivre.",
  "about.domain_blocks.silenced.title": "Limité",
  "about.domain_blocks.suspended.explanation": "Aucune donnée de ce serveur ne sera traitée, enregistrée ou échangée, rendant impossible toute interaction ou communication avec les comptes de ce serveur.",
  "about.domain_blocks.suspended.title": "Suspendu",
  "about.language_label": "Langue",
  "about.not_available": "Cette information n'a pas été rendue disponible sur ce serveur.",
  "about.powered_by": "Réseau social décentralisé propulsé par {mastodon}",
  "about.rules": "Règles du serveur",
  "account.account_note_header": "Note personnelle",
  "account.activity": "Activité",
  "account.add_note": "Ajouter une note personnelle",
  "account.add_or_remove_from_list": "Ajouter ou retirer des listes",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Bloqué·e",
  "account.badges.bot": "Robot",
  "account.badges.domain_blocked": "Domaine bloqué",
  "account.badges.group": "Groupe",
  "account.badges.muted": "Masqué·e",
  "account.badges.muted_until": "Masqué·e jusqu’au {until}",
  "account.block": "Bloquer @{name}",
  "account.block_domain": "Bloquer le domaine {domain}",
  "account.block_short": "Bloquer",
  "account.blocked": "Bloqué·e",
  "account.cancel_follow_request": "Annuler l'abonnement",
  "account.copy": "Copier le lien du profil",
  "account.direct": "Mentionner @{name} en privé",
  "account.disable_notifications": "Ne plus me notifier les publications de @{name}",
  "account.edit_note": "Modifier la note personnelle",
  "account.edit_profile": "Modifier le profil",
  "account.edit_profile_short": "Modifier",
  "account.enable_notifications": "Me notifier les publications de @{name}",
  "account.endorse": "Recommander sur votre profil",
  "account.familiar_followers_many": "Suivi·e par {name1}, {name2}, et {othersCount, plural, one {une autre personne que vous suivez} other {# autres personnes que vous suivez}}",
  "account.familiar_followers_one": "Suivi·e par {name1}",
  "account.familiar_followers_two": "Suivi·e par {name1} et {name2}",
  "account.featured": "En vedette",
  "account.featured.accounts": "Profils",
  "account.featured.collections": "Collections",
  "account.featured.new_collection": "Nouvelle collection",
  "account.field_overflow": "Voir tout",
  "account.filters.all": "Toutes les activités",
  "account.filters.boosts_toggle": "Afficher les partages",
  "account.filters.posts_boosts": "Messages et partages",
  "account.filters.posts_only": "Messages",
  "account.filters.posts_replies": "Messages et réponses",
  "account.filters.replies_toggle": "Afficher les réponses",
  "account.follow": "Suivre",
  "account.follow_back": "Suivre en retour",
  "account.follow_back_short": "Suivre en retour",
  "account.follow_request": "Demander à suivre",
  "account.follow_request_cancel": "Annuler la demande",
  "account.follow_request_cancel_short": "Annuler",
  "account.follow_request_short": "Demander à suivre",
  "account.followers": "Abonné·e·s",
  "account.followers.empty": "Personne ne suit cet·te utilisateur·rice pour l’instant.",
  "account.followers_counter": "{count, plural, one {{counter} abonné·e} other {{counter} abonné·e·s}}",
  "account.followers_you_know_counter": "{counter} que vous suivez",
  "account.following": "Abonnements",
  "account.following_counter": "{count, plural, one {{counter} abonnement} other {{counter} abonnements}}",
  "account.follows.empty": "Cet·te utilisateur·rice ne suit personne pour l’instant.",
  "account.follows_you": "Vous suit",
  "account.go_to_profile": "Voir le profil",
  "account.hame.invalid_handle": "Identifiant non disponible",
  "account.hide_reblogs": "Masquer les partages de @{name}",
  "account.in_memoriam": "En mémoire.",
  "account.join_modal.day": "Jour",
  "account.join_modal.me": "Vous avez rejoint {server} le",
  "account.join_modal.me_anniversary": "Joyeux Fédiversaire ! Vous avez rejoint {server} le",
  "account.join_modal.me_today": "C'est votre premier jour sur {server} !",
  "account.join_modal.other": "{name} a rejoint {server} le",
  "account.join_modal.other_today": "C'est le premier jour de {name} sur {server} !",
  "account.join_modal.share.celebrate": "Partager un message de célébration",
  "account.join_modal.share.intro": "Partager un message d'introduction",
  "account.join_modal.share.welcome": "Partager un message de bienvenue",
  "account.join_modal.years": "{number, plural, one {an} other {ans}}",
  "account.joined_short": "Ici depuis",
  "account.languages": "Modifier les langues d'abonnements",
  "account.last_active": "Dernière activité",
  "account.link_verified_on": "La propriété de ce lien a été vérifiée le {date}",
  "account.locked_info": "Ce compte est privé. Son ou sa propriétaire approuve manuellement qui peut le suivre.",
  "account.media": "Médias",
  "account.mention": "Mentionner @{name}",
  "account.menu.add_to_collection": "Ajouter à une collection…",
  "account.menu.add_to_list": "Ajouter à la liste…",
  "account.menu.block": "Bloquer le compte",
  "account.menu.block_domain": "Bloquer {domain}",
  "account.menu.copied": "Lien du compte copié dans le presse-papiers",
  "account.menu.copy": "Copier le lien",
  "account.menu.direct": "Mentionner en privé",
  "account.menu.hide_reblogs": "Masquer les partages dans le fil d’actualité",
  "account.menu.mention": "Mentionner",
  "account.menu.mute": "Masquer le compte",
  "account.menu.note.description": "Visible uniquement par vous",
  "account.menu.open_original_page": "Voir sur {domain}",
  "account.menu.open_original_page_no_domain": "Voir sur le serveur d'origine",
  "account.menu.remove_follower": "Supprimer des abonné·e·s",
  "account.menu.report": "Signaler le compte",
  "account.menu.share": "Partager…",
  "account.menu.show_reblogs": "Afficher les partages dans le fil d'actualité",
  "account.menu.unblock": "Débloquer le compte",
  "account.menu.unblock_domain": "Débloquer {domain}",
  "account.menu.unmute": "Ne plus masquer le compte",
  "account.moved_to": "{name} a indiqué que son nouveau compte est maintenant :",
  "account.mute": "Masquer @{name}",
  "account.mute_notifications_short": "Désactiver les notifications",
  "account.mute_short": "Masquer",
  "account.muted": "Masqué·e",
  "account.mutual": "Vous vous suivez mutuellement",
  "account.name.copy": "Copier l’identifiant",
  "account.name.help.domain": "{domain} est le serveur qui héberge le profil et les messages du compte.",
  "account.name.help.domain_self": "{domain} est le serveur qui héberge votre profil et vos messages.",
  "account.name.help.footer": "Tout comme vous pouvez envoyer des courriels à des personnes utilisant différents fournisseurs de messagerie, vous pouvez interagir avec des personnes sur d'autres serveurs Mastodon, ainsi qu'avec n'importe qui utilisant une application du Fédivers.",
  "account.name.help.header": "Un identifiant est comme une adresse de courriel",
  "account.name.help.invalid_explanation": "Cela peut se produire lorsqu'un compte change de nom et est généralement temporaire. Si cela persiste, cela peut être dû à un serveur indisponible ou à une configuration erronée du compte.",
  "account.name.help.invalid_header": "L'identifiant de ce compte est en cours de mise à jour",
  "account.name.help.username": "{username} est le nom d'utilisateur·ice de ce compte sur son serveur. Quelqu'un sur un autre serveur peut avoir le même nom.",
  "account.name.help.username_self": "{username} est votre nom d'utilisateur·ice sur ce serveur. Quelqu'un sur un autre serveur peut avoir le même nom.",
  "account.name_info": "Qu'est-ce que cela signifie ?",
  "account.no_bio": "Aucune description fournie.",
  "account.node_modal.callout": "Les notes personnelles sont ne sont visibles que pour vous.",
  "account.node_modal.edit_title": "Modifier la note personnelle",
  "account.node_modal.error_unknown": "Impossible d'enregistrer la note",
  "account.node_modal.field_label": "Note personnelle",
  "account.node_modal.save": "Enregistrer",
  "account.node_modal.title": "Ajouter une note personnelle",
  "account.note.edit_button": "Modifier",
  "account.note.title": "Note personnelle (visible uniquement pour vous)",
  "account.open_original_page": "Ouvrir la page d'origine",
  "account.pending": "En attente",
  "account.posts": "Messages",
  "account.remove_from_followers": "Retirer {name} des abonnés",
  "account.report": "Signaler @{name}",
  "account.requested_follow": "{name} a demandé à vous suivre",
  "account.share": "Partager le profil de @{name}",
  "account.show_reblogs": "Afficher les partages de @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} message} other {{counter} messages}}",
  "account.timeline.pinned": "Épinglé",
  "account.timeline.pinned.view_all": "Voir tous les messages épinglés",
  "account.unblock": "Débloquer @{name}",
  "account.unblock_domain": "Débloquer le domaine {domain}",
  "account.unblock_domain_short": "Débloquer",
  "account.unblock_short": "Débloquer",
  "account.unendorse": "Ne plus recommander sur le profil",
  "account.unfollow": "Ne plus suivre",
  "account.unmute": "Ne plus masquer @{name}",
  "account.unmute_notifications_short": "Réactiver les notifications",
  "account.unmute_short": "Ne plus masquer",
  "account_edit.advanced_settings.bot_hint": "Indique que le compte effectue principalement des actions automatisées et pourrait ne pas être surveillé",
  "account_edit.advanced_settings.bot_label": "Compte robot",
  "account_edit.advanced_settings.title": "Paramètres avancés",
  "account_edit.bio.add_label": "Ajouter une présentation",
  "account_edit.bio.edit_label": "Modifier la présentation",
  "account_edit.bio.placeholder": "Ajouter une courte présentation pour aider les autres à vous connaître.",
  "account_edit.bio.title": "Présentation",
  "account_edit.bio_modal.add_title": "Ajouter une présentation",
  "account_edit.bio_modal.edit_title": "Modifier la présentation",
  "account_edit.column_button": "Terminé",
  "account_edit.column_title": "Modifier le profil",
  "account_edit.custom_fields.add_label": "Ajouter un champ",
  "account_edit.custom_fields.edit_label": "Modifier le champ",
  "account_edit.custom_fields.placeholder": "Ajouter vos pronoms, vos sites, ou tout ce que vous voulez partager.",
  "account_edit.custom_fields.reorder_button": "Réorganiser les champs",
  "account_edit.custom_fields.tip_content": "Vous pouvez facilement ajouter de la crédibilité à votre compte Mastodon en vérifiant les liens vers tous les sites Web que vous possédez.",
  "account_edit.custom_fields.tip_title": "Astuce : ajout de liens vérifiés",
  "account_edit.custom_fields.title": "Champs personnalisés",
  "account_edit.custom_fields.verified_hint": "Comment ajouter un lien vérifié ?",
  "account_edit.display_name.add_label": "Ajouter un nom public",
  "account_edit.display_name.edit_label": "Modifier le nom public",
  "account_edit.display_name.placeholder": "Votre nom public est le nom qui apparaît sur votre profil et dans les fils d'actualités.",
  "account_edit.display_name.title": "Nom public",
  "account_edit.featured_hashtags.edit_label": "Ajouter des hashtags",
  "account_edit.featured_hashtags.placeholder": "Aider les autres à identifier et à accéder rapidement à vos sujets préférés.",
  "account_edit.featured_hashtags.title": "Hashtags mis en avant",
  "account_edit.field_actions.delete": "Supprimer le champ",
  "account_edit.field_actions.edit": "Modifier le champ",
  "account_edit.field_delete_modal.confirm": "Voulez-vous vraiment supprimer ce champ personnalisé ? Cette action ne peut pas être annulée.",
  "account_edit.field_delete_modal.delete_button": "Supprimer",
  "account_edit.field_delete_modal.title": "Supprimer le champ personnalisé ?",
  "account_edit.field_edit_modal.add_title": "Ajouter un champ personnalisé",
  "account_edit.field_edit_modal.discard_confirm": "Abandonner",
  "account_edit.field_edit_modal.discard_message": "Vos modifications n’ont pas été enregistrées. Voulez-vous vraiment les abandonner ?",
  "account_edit.field_edit_modal.edit_title": "Modifier un champ personnalisé",
  "account_edit.field_edit_modal.length_warning": "Le nombre de caractères dépasse la limite recommandée. Le champ peut ne pas s'afficher entièrement sur les téléphones.",
  "account_edit.field_edit_modal.link_emoji_warning": "Nous déconseillons l'usage d'émojis personnalisés avec les URL. Les champs personnalisés contenant les deux seront affichés comme du texte et non un lien, afin d'éviter toute confusion.",
  "account_edit.field_edit_modal.name_hint": "Par exemple « Site Web personnel »",
  "account_edit.field_edit_modal.name_label": "Libellé",
  "account_edit.field_edit_modal.url_warning": "Pour ajouter un lien, veuillez inclure {protocol} au début.",
  "account_edit.field_edit_modal.value_hint": "Par exemple « https://exemple.me »",
  "account_edit.field_edit_modal.value_label": "Valeur",
  "account_edit.field_reorder_modal.drag_cancel": "Déplacement annulé. Le champ « {item} » a été redéposé.",
  "account_edit.field_reorder_modal.drag_end": "Le champ « {item} » a été déposé.",
  "account_edit.field_reorder_modal.drag_instructions": "Pour réorganiser les champs personnalisés, appuyer sur espace ou entrée. Utiliser les touches fléchées pour déplacer le champ vers le haut ou vers le bas. Appuyer à nouveau sur espace ou entrée pour déposer le champ dans sa nouvelle position, ou appuyer sur échap pour annuler.",
  "account_edit.field_reorder_modal.drag_move": "Le champ « {item} » a été déplacé.",
  "account_edit.field_reorder_modal.drag_over": "Le champ « {item} » a été déplacé au-dessus de « {over} ».",
  "account_edit.field_reorder_modal.drag_start": "Champ « {item} » sélectionné.",
  "account_edit.field_reorder_modal.handle_label": "Faites glisser le champ « {item} »",
  "account_edit.field_reorder_modal.title": "Réorganiser les champs",
  "account_edit.image_alt_modal.add_title": "Ajouter un texte alternatif",
  "account_edit.image_alt_modal.details_content": "À faire : <ul> <li>Se décrire comme vous apparaissez sur la photo</li> <li>Utiliser la troisième personne (par exemple « Alex » au lieu de « moi »)</li> <li>Être succinct·e – quelques mot suffisent souvent</li> </ul> À éviter : <ul> <li>Commencer par « Une photo de » – c'est redondant pour les lecteurs d'écran</li> </ul> Example : <ul> <li>« Alex portant une chemise vert et des lunettes »</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Astuces : texte alternatif pour les photos de profil",
  "account_edit.image_alt_modal.edit_title": "Modifier le texte alternatif",
  "account_edit.image_alt_modal.text_hint": "Le texte alternatif aide les personnes utilisant un lecteur d'écran à comprendre votre contenu.",
  "account_edit.image_alt_modal.text_label": "Texte alternatif",
  "account_edit.image_delete_modal.confirm": "Voulez-vous vraiment supprimer cette image ? Cette action est irréversible.",
  "account_edit.image_delete_modal.delete_button": "Supprimer",
  "account_edit.image_delete_modal.title": "Supprimer l'image ?",
  "account_edit.image_edit.add_button": "Ajouter une image",
  "account_edit.image_edit.alt_add_button": "Ajouter un texte alternatif",
  "account_edit.image_edit.alt_edit_button": "Modifier le texte alternatif",
  "account_edit.image_edit.remove_button": "Supprimer l’image",
  "account_edit.image_edit.replace_button": "Remplacer l'image",
  "account_edit.item_list.delete": "Supprimer {name}",
  "account_edit.item_list.edit": "Modifier {name}",
  "account_edit.name_modal.add_title": "Ajouter un nom public",
  "account_edit.name_modal.edit_title": "Modifier le nom public",
  "account_edit.profile_tab.button_label": "Personnaliser",
  "account_edit.profile_tab.hint.description": "Ces paramètres personnalisent ce que les personnes voient sur {server} dans les applications officielles, mais ils peuvent ne pas s'appliquer aux personnes sur d'autres serveurs ou utilisant une application tierce.",
  "account_edit.profile_tab.hint.title": "L'affichage peut varier",
  "account_edit.profile_tab.show_featured.description": "« En vedette » est un onglet facultatif où vous pouvez mettre en avant d'autres comptes.",
  "account_edit.profile_tab.show_featured.title": "Afficher l'onglet « En vedette »",
  "account_edit.profile_tab.show_media.description": "« Média » est un onglet facultatif qui affiche vos messages contenant des images ou des vidéos.",
  "account_edit.profile_tab.show_media.title": "Afficher l'onglet « Média »",
  "account_edit.profile_tab.show_media_replies.description": "En activant cette option l'onglet « Média » affiche à la fois vos messages et vos réponses aux messages d'autres personnes.",
  "account_edit.profile_tab.show_media_replies.title": "Inclure les réponses dans l'onglet « Média »",
  "account_edit.profile_tab.show_relations.description": "Affiche vos abonnements et vos abonné·e·s sur votre profil. Les gens seront toujours en mesure de voir si vous les suivez.",
  "account_edit.profile_tab.show_relations.title": "Afficher les abonné·e·s et les abonnements",
  "account_edit.profile_tab.subtitle": "Personnalisez l'affichage de votre profil.",
  "account_edit.profile_tab.title": "Paramètres d'affichage du profil",
  "account_edit.save": "Enregistrer",
  "account_edit.upload_modal.back": "Retour",
  "account_edit.upload_modal.done": "Terminé",
  "account_edit.upload_modal.next": "Suivant",
  "account_edit.upload_modal.step_crop.zoom": "Agrandir",
  "account_edit.upload_modal.step_upload.button": "Parcourir les fichiers",
  "account_edit.upload_modal.step_upload.dragging": "Déposer pour téléverser",
  "account_edit.upload_modal.step_upload.header": "Choisir une image",
  "account_edit.upload_modal.step_upload.hint": "Format WebP, PNG, GIF ou JPEG, jusqu'à {limit} Mo.{br}L'image sera redimensionnée à {width} × {height} px.",
  "account_edit.upload_modal.title_add.avatar": "Ajouter une photo de profil",
  "account_edit.upload_modal.title_add.header": "Ajouter une photo de couverture",
  "account_edit.upload_modal.title_replace.avatar": "Remplacer la photo de profil",
  "account_edit.upload_modal.title_replace.header": "Remplacer la photo de couverture",
  "account_edit.verified_modal.details": "Ajoutez de la crédibilité à votre profil Mastodon en vérifiant les liens vers vos sites Web personnels. Voici comment cela fonctionne :",
  "account_edit.verified_modal.invisible_link.details": "Ajoutez le lien dans votre en-tête. La partie importante est « rel=\"me\" » qui empêche l'usurpation d'identité sur des sites Web ayant du contenu généré par d'autres utilisateur·rice·s. Vous pouvez aussi utiliser une balise link dans l'en-tête de la page au lieu de {tag}, mais le code HTML doit être accessible sans avoir besoin d'exécuter du JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Comment rendre le lien invisible ?",
  "account_edit.verified_modal.step1.header": "Copiez le code HTML ci-dessous dans l'en-tête de votre site Web",
  "account_edit.verified_modal.step2.details": "Si vous avez déjà ajouté votre site Web en tant que champ personnalisé, vous devrez le supprimer et le rajouter pour déclencher la vérification.",
  "account_edit.verified_modal.step2.header": "Ajoutez votre site Web en tant que champ personnalisé",
  "account_edit.verified_modal.title": "Comment ajouter un lien vérifié ?",
  "account_edit_tags.add_tag": "Ajouter #{tagName}",
  "account_edit_tags.column_title": "Modifier les hashtags",
  "account_edit_tags.help_text": "Les hashtags mis en avant aident les personnes à découvrir et interagir avec votre profil. Ils apparaissent comme des filtres dans la vue « Activité » de votre profil.",
  "account_edit_tags.max_tags_reached": "Vous avez atteint le nombre maximum de hashtags mis en avant.",
  "account_edit_tags.search_placeholder": "Saisir un hashtag…",
  "account_edit_tags.suggestions": "Suggestions :",
  "account_edit_tags.tag_status_count": "{count, plural, one {# message} other {# messages}}",
  "account_list.hidden_notice": "Ceci n'est visible que pour vous. Pour afficher cette liste aux autres, allez à <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# compte} other {# comptes}}",
  "admin.dashboard.daily_retention": "Taux de rétention des utilisateur·rice·s par jour après inscription",
  "admin.dashboard.monthly_retention": "Taux de rétention des utilisateur·rice·s par mois après inscription",
  "admin.dashboard.retention.average": "Moyenne",
  "admin.dashboard.retention.cohort": "Mois d'inscription",
  "admin.dashboard.retention.cohort_size": "Nouveaux comptes",
  "admin.impact_report.instance_accounts": "Profils de comptes que cela supprimerait",
  "admin.impact_report.instance_followers": "Abonné·e·s que nos utilisateur·rice·s perdraient",
  "admin.impact_report.instance_follows": "Abonné·e·s que leurs utilisateur·rice·s perdraient",
  "admin.impact_report.title": "Résumé de l'impact",
  "alert.need_reload.message": "Mastodon a été mis à jour. Il peut y avoir des dysfonctionnements tant que vous ne rechargez pas la page.",
  "alert.rate_limited.message": "Veuillez réessayer après {retry_time, time, medium}.",
  "alert.rate_limited.title": "Nombre de requêtes limité",
  "alert.unexpected.message": "Une erreur inattendue s’est produite.",
  "alert.unexpected.title": "Oups !",
  "alt_text_badge.title": "Texte alternatif",
  "alt_text_modal.add_alt_text": "Ajouter un texte alternatif",
  "alt_text_modal.add_text_from_image": "Extraire le texte de l'image",
  "alt_text_modal.cancel": "Annuler",
  "alt_text_modal.change_thumbnail": "Changer la vignette",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Décrire pour les personnes ayant des difficultés d’audition…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Décrire pour les personnes ayant des problèmes de vue…",
  "alt_text_modal.done": "Terminé",
  "announcement.announcement": "Annonce",
  "annual_report.announcement.action_build": "Générer mon Wrapstodon",
  "annual_report.announcement.action_dismiss": "Non merci",
  "annual_report.announcement.action_view": "Voir mon Wrapstodon",
  "annual_report.announcement.description": "En savoir plus concernant votre activité sur Mastodon pour l'année écoulée.",
  "annual_report.announcement.title": "Le Wrapstodon {year} est arrivé",
  "annual_report.nav_item.badge": "Nouveau",
  "annual_report.shared_page.donate": "Faire un don",
  "annual_report.shared_page.footer": "Généré avec {heart} par l'équipe de Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} utilise {domain}, l'une des nombreuses communautés propulsées par Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} fut à l’affût des messages à partager, ciblant avec perfection les créatrices et créateurs à amplifier.",
  "annual_report.summary.archetype.booster.desc_self": "Vous avez été à l'affût des messages à partager, ciblant avec perfection les créatrices et créateurs à amplifier.",
  "annual_report.summary.archetype.booster.name": "Archer, archère",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Nous savons que {name} a été là, quelque part, profitant discrètement de Mastodon à sa manière.",
  "annual_report.summary.archetype.lurker.desc_self": "Nous savons que vous avez été là, quelque part, profitant discrètement de Mastodon à votre manière.",
  "annual_report.summary.archetype.lurker.name": "Stoïque",
  "annual_report.summary.archetype.oracle.desc_public": "{name} publia plus de nouveaux messages que de réponses, contribuant à garder Mastodon frais et tourné vers l'avenir.",
  "annual_report.summary.archetype.oracle.desc_self": "Vous avez publié plus de nouveaux messages que de réponses, contribuant à garder Mastodon frais et tourné vers l'avenir.",
  "annual_report.summary.archetype.oracle.name": "Oracle",
  "annual_report.summary.archetype.pollster.desc_public": "{name} publia plus de sondages que n'importe quel autre type de message, cultivant la curiosité sur Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Vous avez publié plus de sondages que n'importe quel autre type de message, cultivant la curiosité sur Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Curieux, curieuse",
  "annual_report.summary.archetype.replier.desc_public": "{name} répliqua fréquemment aux messages des autres, pollinisant Mastodon de nouvelles discussions.",
  "annual_report.summary.archetype.replier.desc_self": "Vous avez fréquemment répliqué aux messages des autres, pollinisant Mastodon de nouvelles discussions.",
  "annual_report.summary.archetype.replier.name": "Papillon",
  "annual_report.summary.archetype.reveal": "Révéler mon archétype",
  "annual_report.summary.archetype.reveal_description": "Merci de faire partie de Mastodon ! Il est temps de découvrir quel archétype vous avez incarné en {year}.",
  "annual_report.summary.archetype.title_public": "L'archétype de {name}",
  "annual_report.summary.archetype.title_self": "Votre archétype",
  "annual_report.summary.close": "Fermer",
  "annual_report.summary.copy_link": "Copier le lien",
  "annual_report.summary.followers.new_followers": "{count, plural, one {nouvel·le abonné·e} other {nouveaux abonné·e·s}}",
  "annual_report.summary.highlighted_post.boost_count": "Ce message a été partagé {count, plural, one {une fois} other {# fois}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Ce message a été mis en favoris {count, plural, one {une fois} other {# fois}}.",
  "annual_report.summary.highlighted_post.reply_count": "Ce message a reçu {count, plural, one {une réponse} other {# réponses}}.",
  "annual_report.summary.highlighted_post.title": "Message le plus populaire",
  "annual_report.summary.most_used_app.most_used_app": "appli la plus utilisée",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "hashtag le plus utilisé",
  "annual_report.summary.most_used_hashtag.used_count": "Vous avez utilisé ce hashtag dans {count, plural, one {un message} other {# messages}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} a inclus ce hashtag dans {count, plural, one {un message} other {# messages}}.",
  "annual_report.summary.new_posts.new_posts": "nouveaux messages",
  "annual_report.summary.percentile.text": "<topLabel>Cela vous place dans le top</topLabel><percentage></percentage><bottomLabel>des utilisateur·ice·s de {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Nous ne le dirons pas à Bernie.",
  "annual_report.summary.share_elsewhere": "Partager autre part",
  "annual_report.summary.share_message": "J’ai obtenu l’archétype {archetype} !",
  "annual_report.summary.share_on_mastodon": "Partager sur Mastodon",
  "attachments_list.unprocessed": "(non traité)",
  "audio.hide": "Masquer l'audio",
  "block_modal.no_collections": "Aucun de vous ne peut ajouter l'autre à une collection. Le cas échéant chacun sera automatiquement supprimé·e des collections existantes de l'autre.",
  "block_modal.remote_users_caveat": "Nous allons demander au serveur {domain} de respecter votre décision. Cependant, ce respect n'est pas garanti, car certains serveurs peuvent gérer différemment les blocages. Les messages publics peuvent rester visibles par les utilisateur·rice·s non connecté·e·s.",
  "block_modal.show_less": "Afficher moins",
  "block_modal.show_more": "Afficher plus",
  "block_modal.they_cant_mention": "Vous ne pouvez pas vous mentionner, suivre ou citer l'un l'autre.",
  "block_modal.they_cant_see_posts": "Aucun de vous ne pourra voir le contenu de l'autre.",
  "block_modal.they_will_know": "Iel pourra voir qu'iel est bloqué·e.",
  "block_modal.title": "Bloquer l'utilisateur·rice ?",
  "block_modal.you_wont_see_mentions": "Vous ne verrez plus les messages qui le ou la mentionnent.",
  "boost_modal.combo": "Vous pouvez appuyer sur {combo} pour passer ceci la prochaine fois",
  "boost_modal.reblog": "Partager le message ?",
  "boost_modal.undo_reblog": "Annuler le partage du message ?",
  "bundle_column_error.copy_stacktrace": "Copier le rapport d'erreur",
  "bundle_column_error.error.body": "La page demandée n'a pas pu être affichée. Cela peut être dû à un bogue dans notre code, ou à un problème de compatibilité avec le navigateur.",
  "bundle_column_error.error.title": "Oh non !",
  "bundle_column_error.network.body": "Une erreur s'est produite lors du chargement de cette page. Cela peut être dû à un problème temporaire avec votre connexion internet ou avec ce serveur.",
  "bundle_column_error.network.title": "Erreur réseau",
  "bundle_column_error.retry": "Réessayer",
  "bundle_column_error.return": "Retourner à l'accueil",
  "bundle_column_error.routing.body": "La page demandée est introuvable. Est-ce que l'URL dans la barre d’adresse est correcte ?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Fermer",
  "bundle_modal_error.message": "Une erreur s’est produite lors du chargement de cet écran.",
  "bundle_modal_error.retry": "Réessayer",
  "callout.dismiss": "Rejeter",
  "carousel.current": "<sr>Diapositive</sr> {current, number} / {max, number}",
  "carousel.slide": "Diapositive {current, number} sur {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} caractères recommandés",
  "character_counter.required": "{currentLength}/{maxLength} caractères",
  "closed_registrations.other_server_instructions": "Puisque Mastodon est décentralisé, vous pouvez créer un compte sur un autre serveur et interagir quand même avec celui-ci.",
  "closed_registrations_modal.description": "Créer un compte sur {domain} est actuellement impossible, néanmoins souvenez-vous que vous n'avez pas besoin d'un compte spécifiquement sur {domain} pour utiliser Mastodon.",
  "closed_registrations_modal.find_another_server": "Trouver un autre serveur",
  "closed_registrations_modal.preamble": "Mastodon est décentralisé : peu importe où vous créez votre compte, vous serez en mesure de suivre et d'interagir avec quiconque sur ce serveur. Vous pouvez même l'héberger !",
  "closed_registrations_modal.title": "Inscription sur Mastodon",
  "collection.share_modal.share_link_label": "Partager le lien",
  "collection.share_modal.share_via_post": "Publier sur Mastodon",
  "collection.share_modal.share_via_system": "Partager avec…",
  "collection.share_modal.title": "Partager la collection",
  "collection.share_modal.title_new": "Partager votre nouvelle collection !",
  "collection.share_template_other": "Découvrez cette collection incroyable :",
  "collection.share_template_own": "Découvrez ma nouvelle collection :",
  "collections.account_count": "{count, plural, one {# compte} other {# comptes}}",
  "collections.accounts.empty_description": "Ajoutez jusqu'à {count} comptes",
  "collections.accounts.empty_editor_title": "Il n'y a personne dans cette collection",
  "collections.accounts.empty_title": "Cette collection est vide",
  "collections.add_to_collection": "Ajouter {name} aux collections",
  "collections.block_collection_owner": "Bloquer le compte",
  "collections.by_account": "par {account_handle}",
  "collections.collection_description": "Description",
  "collections.collection_language": "Langue",
  "collections.collection_language_none": "Aucune",
  "collections.collection_name": "Nom",
  "collections.collection_topic": "Sujet",
  "collections.confirm_account_removal": "Voulez-vous vraiment supprimer ce compte de la collection ?",
  "collections.content_warning": "Avertissement au public",
  "collections.continue": "Continuer",
  "collections.copy_link": "Copier le lien",
  "collections.copy_link_confirmation": "Lien de la collection copié dans le presse-papiers",
  "collections.create.accounts_title": "Qui voulez-vous mettre en avant dans cette collection ?",
  "collections.create.basic_details_title": "Informations générales",
  "collections.create.steps": "Étape {step}/{total}",
  "collections.create_collection": "Créer une collection",
  "collections.create_new_collection": "Créer une collection",
  "collections.delete_collection": "Supprimer la collection",
  "collections.description_length_hint": "Maximum 100 caractères",
  "collections.detail.author_added_you_on_date": "{author} vous a ajouté·e le {date}",
  "collections.detail.loading": "Chargement de la collection…",
  "collections.detail.revoke_inclusion": "Me retirer",
  "collections.detail.sensitive_content": "Contenu sensible",
  "collections.detail.sensitive_note": "La description et les comptes peuvent ne pas convenir à tous les publics.",
  "collections.detail.share": "Partager la collection",
  "collections.detail.you_are_in_this_collection": "Vous faites partie de cette collection",
  "collections.edit_details": "Modifier les détails",
  "collections.error_loading_collections": "Une erreur s'est produite durant le chargement de ces collections.",
  "collections.hidden_accounts_description": "Vous avez bloqué ou masqué {count, plural, one {ce compte} other {ces comptes}}",
  "collections.hidden_accounts_link": "{count, plural, one {# compte caché} other {# comptes cachés}}",
  "collections.hints.accounts_counter": "{count}/{max} comptes",
  "collections.last_updated_at": "Dernière mise à jour : {date}",
  "collections.list.collections_with_count": "{count, plural, one {# collection} other {# collections}}",
  "collections.list.created_by_author": "Créée par {name}",
  "collections.list.created_by_you": "Créées par vous",
  "collections.list.featuring_you": "Avec vous",
  "collections.manage_accounts": "Gérer les comptes",
  "collections.mark_as_sensitive": "Marquer comme sensible",
  "collections.mark_as_sensitive_hint": "Masque la description et les comptes de la collection derrière un avertissement au public. Le titre reste visible.",
  "collections.maximum_collection_count_description": "Votre serveur permet la création de {count} collections au maximum.",
  "collections.maximum_collection_count_reached": "Vous avez créé le nombre maximum de collections",
  "collections.name_length_hint": "Maximum 40 caractères",
  "collections.new_collection": "Nouvelle collection",
  "collections.pending_accounts.message": "Des comptes peuvent apparaître en attente lorsque nous attendons une réponse de l'utilisateur·ice ou de son serveur. Les comptes en attente sont visibles uniquement pour vous.",
  "collections.pending_accounts.title": "Pourquoi est-ce que je vois des comptes en attente ?",
  "collections.remove_account": "Supprimer",
  "collections.report_collection": "Signaler cette collection",
  "collections.revoke_collection_inclusion": "Me retirer de cette collection",
  "collections.revoke_inclusion.confirmation": "Vous avez été retiré·e de « {collection} »",
  "collections.revoke_inclusion.error": "Une erreur s'est produite, veuillez réessayer plus tard.",
  "collections.search_accounts_label": "Recherchez un compte à ajouter",
  "collections.search_accounts_max_reached": "Vous avez ajouté le nombre maximum de comptes",
  "collections.sensitive": "Sensible",
  "collections.share_short": "Partager",
  "collections.sort_alphabetical": "Alphabétique",
  "collections.sort_by": "Trier par :",
  "collections.sort_date_added": "Date d'ajout",
  "collections.sort_last_active": "Dernière activité",
  "collections.sort_most_followers": "Nombre d'abonné·e·s",
  "collections.suggestions.can_not_add": "Ne peut pas être ajouté",
  "collections.suggestions.can_not_add_desc": "Ces comptes peuvent avoir choisi de ne pas être découverts, ou ils peuvent être sur un serveur qui ne supporte pas les collections.",
  "collections.suggestions.must_follow": "Vous devez d'abord suivre",
  "collections.suggestions.must_follow_desc": "Ces comptes valident leurs demandes d'abonnements. Les abonné·e·s peuvent les ajouter aux collections.",
  "collections.topic_hint": "Ajouter un hashtag pour aider les autres personnes à comprendre le sujet de la collection.",
  "collections.topic_special_chars_hint": "Les caractères spéciaux seront supprimés lors de l'enregistrement",
  "collections.unlisted_collections_description": "Celles-ci n'apparaissent pas sur votre profil. N'importe qui ayant leur lien peut les découvrir.",
  "collections.unlisted_collections_with_count": "Collections non listées ({count})",
  "collections.view_collection": "Voir la collection",
  "collections.visibility_public": "Publique",
  "collections.visibility_public_hint": "Visible dans les résultats de recherche et les recommandations.",
  "collections.visibility_title": "Visibilité",
  "collections.visibility_unlisted": "Non listée",
  "collections.visibility_unlisted_hint": "Visible pour les personnes ayant le lien. N'apparaît pas dans les résultats de recherche et les recommandations.",
  "column.about": "À propos",
  "column.blocks": "Comptes bloqués",
  "column.bookmarks": "Marque-pages",
  "column.community": "Fil local",
  "column.create_list": "Créer une liste",
  "column.direct": "Mentions privées",
  "column.directory": "Parcourir les profils",
  "column.domain_blocks": "Domaines bloqués",
  "column.edit_list": "Modifier la liste",
  "column.favourites": "Favoris",
  "column.firehose": "Flux en direct",
  "column.firehose_local": "Flux en direct pour ce serveur",
  "column.firehose_singular": "Flux en direct",
  "column.follow_requests": "Demandes d'abonnement",
  "column.home": "Accueil",
  "column.list_members": "Gérer les membres de la liste",
  "column.lists": "Listes",
  "column.mutes": "Comptes masqués",
  "column.notifications": "Notifications",
  "column.other_collections": "Les collections par {name}",
  "column.pins": "Messages épinglés",
  "column.public": "Fil fédéré",
  "column.your_collections": "Vos collections",
  "column_back_button.label": "Retour",
  "column_header.hide_settings": "Cacher les paramètres",
  "column_header.moveLeft_settings": "Déplacer la colonne vers la gauche",
  "column_header.moveRight_settings": "Déplacer la colonne vers la droite",
  "column_header.pin": "Épingler",
  "column_header.show_settings": "Afficher les paramètres",
  "column_header.unpin": "Désépingler",
  "column_search.cancel": "Annuler",
  "combobox.close_results": "Fermer les résultats",
  "combobox.loading": "Chargement",
  "combobox.no_results_found": "Aucun résultat pour cette recherche",
  "combobox.open_results": "Ouvrir les résultats",
  "combobox.results_available": "{count, plural, one {# suggestion disponibe} other {# suggestions disponibles}}. Utiliser les touches haut et bas pour naviguer. Appuyer sur Entrée pour sélectionner.",
  "community.column_settings.local_only": "Local seulement",
  "community.column_settings.media_only": "Média uniquement",
  "community.column_settings.remote_only": "Distant seulement",
  "compose.error.blank_post": "Le message ne peut pas être vide.",
  "compose.language.change": "Modifier la langue",
  "compose.language.search": "Rechercher langue…",
  "compose.published.body": "Message publié.",
  "compose.published.open": "Ouvrir",
  "compose.saved.body": "Message enregistré.",
  "compose_form.direct_message_warning_learn_more": "En savoir plus",
  "compose_form.encryption_warning": "Les messages sur Mastodon ne sont pas chiffrés de bout en bout. Ne partagez aucune information sensible sur Mastodon.",
  "compose_form.hashtag_warning": "Ce message n'apparaîtra pas dans les listes de hashtags, car il n'est pas public. Seuls les messages publics peuvent apparaître dans les recherches par hashtags.",
  "compose_form.lock_disclaimer": "Votre compte n’est pas {locked}. Tout le monde peut vous suivre pour voir vos messages réservés à vos abonné⋅e⋅s.",
  "compose_form.lock_disclaimer.lock": "verrouillé",
  "compose_form.placeholder": "Qu’avez-vous en tête ?",
  "compose_form.poll.duration": "Durée du sondage",
  "compose_form.poll.multiple": "Choix multiple",
  "compose_form.poll.option_placeholder": "Option {number}",
  "compose_form.poll.single": "Choix unique",
  "compose_form.poll.switch_to_multiple": "Modifier le sondage pour autoriser plusieurs choix",
  "compose_form.poll.switch_to_single": "Modifier le sondage pour autoriser un seul choix",
  "compose_form.poll.type": "Style",
  "compose_form.publish": "Desu !",
  "compose_form.publish_form": "Nouveau message",
  "compose_form.reply": "Répondre",
  "compose_form.save_changes": "Mettre à jour",
  "compose_form.spoiler.marked": "Enlever l’avertissement de contenu",
  "compose_form.spoiler.unmarked": "Ajouter un avertissement de contenu",
  "compose_form.spoiler_placeholder": "Avertissement de contenu (optionnel)",
  "confirmation_modal.cancel": "Annuler",
  "confirmations.block.confirm": "Bloquer",
  "confirmations.delete.confirm": "Supprimer",
  "confirmations.delete.message": "Voulez-vous vraiment supprimer ce message ?",
  "confirmations.delete.title": "Supprimer le message ?",
  "confirmations.delete_collection.confirm": "Supprimer",
  "confirmations.delete_collection.message": "Cette action ne peut pas être annulée.",
  "confirmations.delete_collection.title": "Supprimer « {name} » ?",
  "confirmations.delete_list.confirm": "Supprimer",
  "confirmations.delete_list.message": "Voulez-vous vraiment supprimer définitivement cette liste ?",
  "confirmations.delete_list.title": "Supprimer la liste ?",
  "confirmations.discard_draft.confirm": "Effacer et continuer",
  "confirmations.discard_draft.edit.cancel": "Reprendre l'édition",
  "confirmations.discard_draft.edit.message": "Si vous continuez, toutes les modifications apportées au message en cours d'édition seront annulées.",
  "confirmations.discard_draft.edit.title": "Annuler les modifications apportées à votre message ?",
  "confirmations.discard_draft.post.cancel": "Retour au brouillon",
  "confirmations.discard_draft.post.message": "Si vous continuez, vous supprimerez le message que vous êtes en train de composer.",
  "confirmations.discard_draft.post.title": "Abandonner votre brouillon ?",
  "confirmations.discard_edit_media.confirm": "Supprimer",
  "confirmations.discard_edit_media.message": "Vous avez des modifications non enregistrées de la description ou de l'aperçu du média. Voulez-vous les supprimer ?",
  "confirmations.follow_to_list.confirm": "Suivre et ajouter à la liste",
  "confirmations.follow_to_list.message": "Vous devez suivre {name} pour l'ajouter à une liste.",
  "confirmations.follow_to_list.title": "Suivre l'utilisateur·rice ?",
  "confirmations.hide_featured_tab.confirm": "Cacher l'onglet",
  "confirmations.hide_featured_tab.intro": "Vous pouvez modifier ce paramétrage à tout moment depuis <i>Modifier le profil > Paramètres de l'onglet du profil</i>.",
  "confirmations.hide_featured_tab.message": "Cela masquera l'onglet pour les utilisateur·rice·s de {serverName} et des autres serveurs utilisant la dernière version de Mastodon. Pour les autres l'affichage peut varier.",
  "confirmations.hide_featured_tab.title": "Cacher l'onglet « En vedette » ?",
  "confirmations.logout.confirm": "Se déconnecter",
  "confirmations.logout.message": "Voulez-vous vraiment vous déconnecter ?",
  "confirmations.logout.title": "Se déconnecter ?",
  "confirmations.missing_alt_text.confirm": "Ajouter un texte alternatif",
  "confirmations.missing_alt_text.message": "Votre message contient des médias sans texte alternatif. L'ajout de descriptions aide à rendre votre contenu accessible à plus de personnes.",
  "confirmations.missing_alt_text.secondary": "Publier quand même",
  "confirmations.missing_alt_text.title": "Ajouter un texte alternatif ?",
  "confirmations.mute.confirm": "Masquer",
  "confirmations.private_quote_notify.cancel": "Retour à l'édition",
  "confirmations.private_quote_notify.confirm": "Publier",
  "confirmations.private_quote_notify.do_not_show_again": "Ne plus afficher ce message",
  "confirmations.private_quote_notify.message": "La personne citée et celles mentionnées seront notifiées et pourront voir le message, même si elles ne vous suivent pas.",
  "confirmations.private_quote_notify.title": "Partager avec les personnes abonnées et mentionnées ?",
  "confirmations.quiet_post_quote_info.dismiss": "Ne plus me rappeler",
  "confirmations.quiet_post_quote_info.got_it": "Compris",
  "confirmations.quiet_post_quote_info.message": "Lorsque vous citez un message public discret, votre message sera caché des fils tendances.",
  "confirmations.quiet_post_quote_info.title": "Citation d'un message public discret",
  "confirmations.redraft.confirm": "Supprimer et réécrire",
  "confirmations.redraft.message": "Voulez-vous vraiment supprimer le message pour le réécrire ? Ses partages ainsi que ses mises en favori seront perdus, et ses réponses seront orphelines.",
  "confirmations.redraft.title": "Supprimer et réécrire le message ?",
  "confirmations.remove_from_followers.confirm": "Supprimer l'abonné·e",
  "confirmations.remove_from_followers.message": "{name} cessera de vous suivre. Voulez-vous vraiment continuer ?",
  "confirmations.remove_from_followers.title": "Supprimer l'abonné·e ?",
  "confirmations.revoke_collection_inclusion.confirm": "Me retirer",
  "confirmations.revoke_collection_inclusion.message": "Le compte gérant la collection ne pourra plus vous y ajouter pendant 24 heures. Pour l'empêcher définitivement de vous ajouter à des collections vous pouvez le bloquer.",
  "confirmations.revoke_collection_inclusion.title": "Vous retirer de cette collection ?",
  "confirmations.revoke_quote.confirm": "Retirer le message",
  "confirmations.revoke_quote.message": "Cette action ne peut pas être annulée.",
  "confirmations.revoke_quote.title": "Retirer le message ?",
  "confirmations.unblock.confirm": "Débloquer",
  "confirmations.unblock.title": "Débloquer {name} ?",
  "confirmations.unfollow.confirm": "Ne plus suivre",
  "confirmations.unfollow.title": "Ne plus suivre {name} ?",
  "confirmations.withdraw_request.confirm": "Retirer la demande",
  "confirmations.withdraw_request.title": "Retirer la demande de suivre {name} ?",
  "content_warning.hide": "Masquer le message",
  "content_warning.show": "Montrer quand même",
  "content_warning.show_more": "Montrer plus",
  "content_warning.show_short": "Afficher",
  "conversation.delete": "Supprimer la conversation",
  "conversation.mark_as_read": "Marquer comme lu",
  "conversation.open": "Afficher la conversation",
  "conversation.with": "Avec {names}",
  "copy_icon_button.copied": "Copié dans le presse-papier",
  "copy_icon_button.copy_this_text": "Copier le lien dans le presse-papier",
  "copypaste.copied": "Copié",
  "copypaste.copy_to_clipboard": "Copier dans le presse-papiers",
  "custom_homepage.about": "À propos",
  "custom_homepage.about_this_server": "À propos de ce serveur",
  "custom_homepage.administered_by": "Administré par",
  "custom_homepage.contact": "Contact :",
  "custom_homepage.latest_activity": "Dernière activité",
  "custom_homepage.these_are_the_latest_posts": "Voici les 40 derniers messages des comptes de ce serveur.",
  "directory.federated": "Du fédivers connu",
  "directory.local": "De {domain} seulement",
  "directory.new_arrivals": "Inscrit·e·s récemment",
  "directory.recently_active": "Actif·ve·s récemment",
  "disabled_account_banner.account_settings": "Paramètres du compte",
  "disabled_account_banner.text": "Votre compte {disabledAccount} est actuellement désactivé.",
  "dismissable_banner.community_timeline": "Voici les messages publics les plus récents des comptes hébergés par {domain}.",
  "dismissable_banner.dismiss": "Fermer",
  "dismissable_banner.public_timeline": "Il s'agit des messages publics les plus récents publiés par des personnes sur le fédivers que les personnes sur {domain} suivent.",
  "domain_block_modal.block": "Bloquer le serveur",
  "domain_block_modal.block_account_instead": "Bloquer @{name} à la place",
  "domain_block_modal.they_can_interact_with_old_posts": "Les personnes de ce serveur peuvent interagir avec vos anciens messages.",
  "domain_block_modal.they_cant_follow": "Personne de ce serveur ne peut vous suivre.",
  "domain_block_modal.they_wont_know": "Les utilisateur·rice·s du serveur ne sauront pas que celui-ci est bloqué.",
  "domain_block_modal.title": "Bloquer le domaine ?",
  "domain_block_modal.you_will_lose_num_followers": "Vous allez perdre {followersCount, plural, one {{followersCountDisplay} abonné·e} other {{followersCountDisplay} abonné·e·s}} et {followingCount, plural, one {{followingCountDisplay} personne que vous suivez} other {{followingCountDisplay} personnes que vous suivez}}.",
  "domain_block_modal.you_will_lose_relationships": "Vous allez perdre tous les abonné·e·s et les personnes que vous suivez sur ce serveur.",
  "domain_block_modal.you_wont_see_posts": "Vous ne verrez plus les messages ou les notifications des utilisateur·rice·s de ce serveur.",
  "dropdown.empty": "Sélectionner une option",
  "email_subscriptions.email": "Adresse de courriel",
  "email_subscriptions.form.action": "S’abonner",
  "email_subscriptions.form.bottom": "Recevez les messages dans votre boîte de réception sans créer de compte Mastodon. Désabonnez-vous quand vous voulez. Pour plus d’information, se référer à la <a>politique de confidentialité</a>.",
  "email_subscriptions.form.title": "Abonnez-vous pour recevoir par courriel les notifications de {name}",
  "email_subscriptions.submitted.lead": "Vérifiez votre boîte de réception pour finaliser de votre inscription aux notifications par courriel.",
  "email_subscriptions.submitted.title": "Une dernière chose",
  "email_subscriptions.validation.email.blocked": "Fournisseur de messagerie bloqué",
  "email_subscriptions.validation.email.invalid": "Adresse de courriel invalide",
  "embed.instructions": "Intégrer ce message à votre site en copiant le code ci-dessous.",
  "embed.preview": "Il apparaîtra comme cela :",
  "emoji_button.activity": "Activités",
  "emoji_button.clear": "Effacer",
  "emoji_button.custom": "Personnalisés",
  "emoji_button.flags": "Drapeaux",
  "emoji_button.food": "Nourriture et boisson",
  "emoji_button.label": "Insérer un émoji",
  "emoji_button.nature": "Nature",
  "emoji_button.not_found": "Aucun émoji correspondant n'a été trouvé",
  "emoji_button.objects": "Objets",
  "emoji_button.people": "Personnes",
  "emoji_button.recent": "Fréquemment utilisés",
  "emoji_button.search": "Recherche...",
  "emoji_button.search_results": "Résultats de la recherche",
  "emoji_button.symbols": "Symboles",
  "emoji_button.travel": "Voyage et lieux",
  "empty_column.account_featured.other": "{acct} n'a pas encore mis de contenu en avant.",
  "empty_column.account_featured_self.no_collections_button": "Créer une collection",
  "empty_column.account_featured_self.no_collections_hide_tab": "Cacher cet onglet",
  "empty_column.account_featured_self.showcase_accounts": "Présentez vos comptes préférés",
  "empty_column.account_featured_self.showcase_accounts_desc": "Les collections sont des listes de comptes sélectionnés pour aider les autres à découvrir le Fédivers.",
  "empty_column.account_featured_unknown.other": "Ce compte n'a mis aucun contenu en avant pour l'instant.",
  "empty_column.account_hides_collections": "Cet utilisateur·ice préfère ne pas rendre publiques ces informations",
  "empty_column.account_suspended": "Compte suspendu",
  "empty_column.account_timeline": "Aucun message ici !",
  "empty_column.account_unavailable": "Profil non disponible",
  "empty_column.blocks": "Vous n’avez bloqué aucun compte pour le moment.",
  "empty_column.bookmarked_statuses": "Vous n'avez pas de message en marque-page. Lorsque vous en ajouterez un, il apparaîtra ici.",
  "empty_column.collections": "{acct} n'a pas encore créé de collection.",
  "empty_column.collections.featured_in": "Vous n'avez pas encore été ajouté·e à une collection.",
  "empty_column.collections.featured_in_undiscoverable": "Afin que l'on puisse vous ajouter à des collections, vous devez autoriser d'apparaître dans les expériences de découverte depuis <link>Vie privée et visibilité</link>",
  "empty_column.collections_self": "Vous n'avez pas encore créé de collection.",
  "empty_column.community": "Le fil public local est vide. Écrivez donc quelque chose pour le remplir !",
  "empty_column.direct": "Vous n'avez pas encore de mentions privées. Quand vous en enverrez ou recevrez, elles apparaîtront ici.",
  "empty_column.disabled_feed": "Ce flux a été désactivé par les administrateur·rice·s de votre serveur.",
  "empty_column.domain_blocks": "Il n’y a aucun domaine bloqué pour le moment.",
  "empty_column.explore_statuses": "Rien n'est en tendance pour le moment. Revenez plus tard !",
  "empty_column.favourited_statuses": "Vous n’avez pas encore de message en favori. Lorsque vous en ajouterez un, il apparaîtra ici.",
  "empty_column.favourites": "Personne n’a encore ajouté ce message à ses favoris. Lorsque quelqu’un le fera, il apparaîtra ici.",
  "empty_column.follow_requests": "Vous n’avez pas encore de demande de suivi. Lorsque vous en recevrez une, elle apparaîtra ici.",
  "empty_column.followed_tags": "Vous n'avez pas encore suivi de hashtags. Lorsque vous le ferez, ils apparaîtront ici.",
  "empty_column.hashtag": "Il n’y a encore aucun contenu associé à ce hashtag.",
  "empty_column.home": "Votre fil d'actualité est vide ! Suivez plus de personnes pour le remplir.",
  "empty_column.list": "Il n’y a rien dans cette liste pour l’instant. Quand des membres de cette liste publieront de nouveaux messages, ils apparaîtront ici.",
  "empty_column.mutes": "Vous n’avez masqué aucun compte pour le moment.",
  "empty_column.notification_requests": "C'est fini ! Il n'y a plus rien ici. Lorsque vous recevez de nouvelles notifications, elles apparaitront ici conformément à vos préférences.",
  "empty_column.notifications": "Vous n’avez pas encore de notification. Interagissez avec d’autres personnes pour commencer la conversation.",
  "empty_column.public": "Il n’y a rien ici ! Écrivez quelque chose publiquement, ou bien suivez manuellement des personnes d’autres serveurs pour remplir le fil d'actualité",
  "empty_state.no_results": "Aucun résultat",
  "error.no_hashtag_feed_access": "Rejoindre ou se connecter pour voir et suivre ce hashtag.",
  "error.unexpected_crash.explanation": "En raison d’un bug dans notre code ou d’un problème de compatibilité avec votre navigateur, cette page n’a pas pu être affichée correctement.",
  "error.unexpected_crash.explanation_addons": "Cette page n’a pas pu être affichée correctement. Cette erreur est probablement causée par une extension de navigateur ou des outils de traduction automatique.",
  "error.unexpected_crash.next_steps": "Essayez de rafraîchir la page. Si cela n’aide pas, vous pouvez toujours utiliser Mastodon via un autre navigateur ou une application native.",
  "error.unexpected_crash.next_steps_addons": "Essayez de les désactiver et de rafraîchir la page. Si cela ne vous aide pas, vous pouvez toujours utiliser Mastodon via un autre navigateur ou une application native.",
  "errors.unexpected_crash.copy_stacktrace": "Copier la trace d'appels dans le presse-papier",
  "errors.unexpected_crash.report_issue": "Signaler le problème",
  "explore.suggested_follows": "Personnes",
  "explore.title": "Tendances",
  "explore.trending_links": "Actualités",
  "explore.trending_statuses": "Messages",
  "explore.trending_tags": "Hashtags",
  "featured_carousel.current": "<sr>Message</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Pinned Post} other {Pinned Posts}}",
  "featured_carousel.slide": "Message {current, number} de {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Récemment, vous avez posté à propos de {items}. Voulez-vous mettre ces hashtags en avant ?",
  "featured_tags.suggestions.add": "Ajouter",
  "featured_tags.suggestions.added": "Gérer vos hashtags mis en avant à tout moment depuis <link>Modifier le profil > Hashtags mis en avant</link>.",
  "featured_tags.suggestions.dismiss": "Non merci",
  "filter_modal.added.context_mismatch_explanation": "Cette catégorie de filtre ne s'applique pas au contexte dans lequel vous avez accédé à ce message. Si vous voulez que le message soit filtré dans ce contexte également, vous devrez modifier le filtre.",
  "filter_modal.added.context_mismatch_title": "Incompatibilité du contexte !",
  "filter_modal.added.expired_explanation": "Cette catégorie de filtre a expiré, vous devrez modifier la date d'expiration pour qu'elle soit appliquée.",
  "filter_modal.added.expired_title": "Filtre expiré !",
  "filter_modal.added.review_and_configure": "Pour examiner et affiner la configuration de cette catégorie de filtres, allez à {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Paramètres du filtre",
  "filter_modal.added.settings_link": "page des paramètres",
  "filter_modal.added.short_explanation": "Ce message a été ajouté à la catégorie de filtre suivante : {title}.",
  "filter_modal.added.title": "Filtre ajouté !",
  "filter_modal.select_filter.context_mismatch": "ne s’applique pas à ce contexte",
  "filter_modal.select_filter.expired": "a expiré",
  "filter_modal.select_filter.prompt_new": "Nouvelle catégorie : {name}",
  "filter_modal.select_filter.search": "Rechercher ou créer",
  "filter_modal.select_filter.subtitle": "Utilisez une catégorie existante ou créez-en une nouvelle",
  "filter_modal.select_filter.title": "Filtrer ce message",
  "filter_modal.title.status": "Filtrer un message",
  "filter_warning.matches_filter": "Correspond au filtre « <span>{title}</span> »",
  "filtered_notifications_banner.pending_requests": "De la part {count, plural, =0 {d’aucune personne} one {d'une personne} other {de # personnes}} que vous pourriez connaître",
  "filtered_notifications_banner.title": "Notifications filtrées",
  "firehose.all": "Tout",
  "firehose.local": "Ce serveur",
  "firehose.remote": "Autres serveurs",
  "follow_request.authorize": "Accepter",
  "follow_request.reject": "Rejeter",
  "follow_requests.unlocked_explanation": "Même si votre compte n’est pas privé, l’équipe de {domain} a pensé que vous pourriez vouloir consulter manuellement les demandes de suivi de ces comptes.",
  "follow_suggestions.curated_suggestion": "Sélectionné par l'équipe",
  "follow_suggestions.dismiss": "Ne plus afficher",
  "follow_suggestions.featured_longer": "Sélectionné par l'équipe de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Populaire dans le cercle des personnes que vous suivez",
  "follow_suggestions.hints.featured": "Ce profil a été sélectionné par l'équipe de {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Ce profil est populaire parmi les personnes que vous suivez.",
  "follow_suggestions.hints.most_followed": "Ce profil est l'un des plus suivis sur {domain}.",
  "follow_suggestions.hints.most_interactions": "Ce profil a récemment fait l'objet d'une grande attention sur {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Ce profil est similaire aux profils que vous avez suivis le plus récemment.",
  "follow_suggestions.personalized_suggestion": "Suggestion personnalisée",
  "follow_suggestions.popular_suggestion": "Suggestion populaire",
  "follow_suggestions.popular_suggestion_longer": "Populaire sur {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Similaire aux profils que vous avez dernièrement suivis",
  "follow_suggestions.view_all": "Tout afficher",
  "follow_suggestions.who_to_follow": "Qui suivre",
  "followed_tags": "Hashtags suivis",
  "followers.hide_other_followers": "Ce compte a choisi de ne pas rendre visible ses autres abonné·e·s",
  "followers.title": "Suit {name}",
  "following.hide_other_following": "Ce compte a choisi de ne pas rendre visible ses autres abonnements",
  "following.title": "Suivi·e par {name}",
  "footer.about": "À propos",
  "footer.about_mastodon": "À propos de Mastodon",
  "footer.about_server": "À propos de {domain}",
  "footer.about_this_server": "À propos",
  "footer.directory": "Annuaire des profils",
  "footer.get_app": "Télécharger l’application",
  "footer.keyboard_shortcuts": "Raccourcis clavier",
  "footer.privacy_policy": "Politique de confidentialité",
  "footer.source_code": "Voir le code source",
  "footer.status": "État",
  "footer.terms_of_service": "Conditions d’utilisation",
  "form_error.blank": "Le champ ne peut pas être vide.",
  "form_field.optional": "(facultatif)",
  "getting_started.heading": "Pour commencer",
  "hashtag.admin_moderation": "Ouvrir l'interface de modération pour #{name}",
  "hashtag.browse": "Parcourir les messages dans #{hashtag}",
  "hashtag.browse_from_account": "Parcourir les messages de @{name} dans #{hashtag}",
  "hashtag.column_header.tag_mode.all": "et {additional}",
  "hashtag.column_header.tag_mode.any": "ou {additional}",
  "hashtag.column_header.tag_mode.none": "sans {additional}",
  "hashtag.column_settings.select.no_options_message": "Aucune suggestion trouvée",
  "hashtag.column_settings.select.placeholder": "Entrer des hashtags…",
  "hashtag.column_settings.tag_mode.all": "Tous ces éléments",
  "hashtag.column_settings.tag_mode.any": "Au moins un de ces éléments",
  "hashtag.column_settings.tag_mode.none": "Aucun de ces éléments",
  "hashtag.column_settings.tag_toggle": "Inclure des hashtags additionnels pour cette colonne",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participant} other {{counter} participants}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} message} other {{counter} messages}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} message} other {{counter} messages}} aujourd’hui",
  "hashtag.feature": "Mettre en avant sur votre profil",
  "hashtag.follow": "Suivre le hashtag",
  "hashtag.mute": "Masquer #{hashtag}",
  "hashtag.unfeature": "Ne plus mettre en avant sur votre profil",
  "hashtag.unfollow": "Ne plus suivre le hashtag",
  "hashtags.and_other": "…et {count, plural, other {# de plus}}",
  "hints.profiles.followers_may_be_missing": "Les abonné·e·s à ce profil peuvent être manquant·e·s.",
  "hints.profiles.follows_may_be_missing": "Les abonnements pour ce profil peuvent être manquants.",
  "hints.profiles.posts_may_be_missing": "Certains messages de ce profil peuvent être manquants.",
  "hints.profiles.see_more_followers": "Afficher plus d'abonné·e·s sur {domain}",
  "hints.profiles.see_more_follows": "Afficher plus d'abonné·e·s sur {domain}",
  "hints.profiles.see_more_posts": "Voir plus de messages sur {domain}",
  "home.column_settings.show_quotes": "Afficher les citations",
  "home.column_settings.show_reblogs": "Afficher les partages",
  "home.column_settings.show_replies": "Afficher les réponses",
  "home.hide_announcements": "Masquer les annonces",
  "home.pending_critical_update.body": "Veuillez mettre à jour votre serveur Mastodon dès que possible !",
  "home.pending_critical_update.link": "Voir les mises à jour",
  "home.pending_critical_update.title": "Une mise à jour de sécurité critique est disponible !",
  "home.show_announcements": "Afficher les annonces",
  "ignore_notifications_modal.bots_title": "Ignorer les notifications des bots ?",
  "ignore_notifications_modal.disclaimer": "Mastodon ne peut pas indiquer aux utilisateur·rice·s que vous avez ignoré leurs notifications. Le fait d'ignorer les notifications n'empêchera pas la transmission des messages eux-mêmes.",
  "ignore_notifications_modal.filter_instead": "Filtrer plutôt",
  "ignore_notifications_modal.filter_to_act_users": "Vous serez toujours en mesure d'accepter, de rejeter ou de signaler les utilisateur·rice·s",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Le filtrage permet d'éviter d'éventuelle confusion",
  "ignore_notifications_modal.filter_to_review_separately": "Vous pouvez examiner les notifications filtrées séparément",
  "ignore_notifications_modal.ignore": "Ignorer les notifications",
  "ignore_notifications_modal.limited_accounts_title": "Ignorer les notifications provenant des comptes modérés ?",
  "ignore_notifications_modal.new_accounts_title": "Ignorer les notifications provenant des nouveaux comptes ?",
  "ignore_notifications_modal.not_followers_title": "Ignorer les notifications provenant des personnes qui ne vous suivent pas ?",
  "ignore_notifications_modal.not_following_title": "Ignorer les notifications provenant des personnes que vous ne suivez pas ?",
  "ignore_notifications_modal.private_mentions_title": "Ignorer les notifications issues des mentions privées non sollicitées ?",
  "info_button.label": "Aide",
  "info_button.what_is_alt_text": "<h1>Qu'est-ce que le texte alternatif ?</h1> <p>Un texte alternatif fournit une description de l'image aux personnes avec un handicap visuel ou une connexion limitée ou qui souhaitent avoir un contexte supplémentaire.</p> <p>Vous pouvez améliorer l'accessibilité et la compression de tout le monde en écrivant un texte alternatif clair, concis et objectif.</p> <ul> <li>Identifiez les éléments importants</li> <li>Résumez le texte présent à l'image</li> <li>Utilisez une structure de phrase normale</li> <li>Évitez les informations redondantes</li> <li>Pour les visuels complexes (tels que les diagrammes ou les cartes), indiquez les tendances ou points-clés</li> </ul>",
  "interaction_modal.action": "Pour interagir avec le message de {name}, vous devez vous connecter à votre compte sur le serveur Mastodon que vous utilisez.",
  "interaction_modal.action_follow": "Pour suivre {name}, vous devez vous connecter à votre compte sur le serveur Mastodon que vous utilisez.",
  "interaction_modal.go": "Valider",
  "interaction_modal.no_account_yet": "Vous n'avez pas encore de compte ?",
  "interaction_modal.on_another_server": "Sur un autre serveur",
  "interaction_modal.on_this_server": "Sur ce serveur",
  "interaction_modal.title": "Connectez-vous pour continuer",
  "interaction_modal.username_prompt": "Par exemple : {example}",
  "intervals.full.days": "{number, plural, one {# jour} other {# jours}}",
  "intervals.full.hours": "{number, plural, one {# heure} other {# heures}}",
  "intervals.full.minutes": "{number, plural, one {# minute} other {# minutes}}",
  "keyboard_shortcuts.back": "Revenir en arrière",
  "keyboard_shortcuts.blocked": "Ouvrir la liste des comptes bloqués",
  "keyboard_shortcuts.boost": "Partager le message",
  "keyboard_shortcuts.column": "Se placer dans une colonne",
  "keyboard_shortcuts.compose": "Se placer dans la zone de rédaction",
  "keyboard_shortcuts.description": "Description",
  "keyboard_shortcuts.direct": "Ouvrir la colonne des mentions privées",
  "keyboard_shortcuts.down": "Descendre dans la liste",
  "keyboard_shortcuts.enter": "Ouvrir le message",
  "keyboard_shortcuts.explore": "Ouvrir le fil des tendances",
  "keyboard_shortcuts.favourite": "Ajouter le message aux favoris",
  "keyboard_shortcuts.favourites": "Ouvrir la liste des favoris",
  "keyboard_shortcuts.federated": "Ouvrir le fil fédéré",
  "keyboard_shortcuts.heading": "Raccourcis clavier",
  "keyboard_shortcuts.home": "Ouvrir le fil d’accueil",
  "keyboard_shortcuts.hotkey": "Raccourci clavier",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Retour arrière",
  "keyboard_shortcuts.keys.enter": "Entrée",
  "keyboard_shortcuts.keys.esc": "Échap",
  "keyboard_shortcuts.keys.page_down": "Page bas",
  "keyboard_shortcuts.keys.page_up": "Page haut",
  "keyboard_shortcuts.legend": "Afficher cet aide-mémoire",
  "keyboard_shortcuts.load_more": "Bouton Focus \"Charger plus\"",
  "keyboard_shortcuts.local": "Ouvrir le fil public local",
  "keyboard_shortcuts.mention": "Mentionner l’auteur·rice",
  "keyboard_shortcuts.muted": "Ouvrir la liste des comptes masqués",
  "keyboard_shortcuts.my_profile": "Ouvrir votre profil",
  "keyboard_shortcuts.notifications": "Ouvrir la colonne de notifications",
  "keyboard_shortcuts.open_media": "Ouvrir le média",
  "keyboard_shortcuts.pinned": "Ouvrir la liste des messages épinglés",
  "keyboard_shortcuts.profile": "Ouvrir le profil de l’auteur·rice",
  "keyboard_shortcuts.quote": "Citer le message",
  "keyboard_shortcuts.reply": "Répondre au message",
  "keyboard_shortcuts.requests": "Ouvrir la liste de demandes d’abonnement",
  "keyboard_shortcuts.search": "Se placer dans le champ de recherche",
  "keyboard_shortcuts.spoilers": "Afficher/cacher le champ de CW",
  "keyboard_shortcuts.start": "Ouvrir la colonne « Pour commencer »",
  "keyboard_shortcuts.toggle_hidden": "Déplier/replier le texte derrière un CW",
  "keyboard_shortcuts.toggle_sensitivity": "Afficher/cacher les médias",
  "keyboard_shortcuts.toot": "Commencer un nouveau message",
  "keyboard_shortcuts.top": "Mettre en tête de liste",
  "keyboard_shortcuts.translate": "Traduire un message",
  "keyboard_shortcuts.unfocus": "Quitter la zone de rédaction/barre de recherche",
  "keyboard_shortcuts.up": "Monter dans la liste",
  "learn_more_link.got_it": "Compris",
  "learn_more_link.learn_more": "En savoir plus",
  "lightbox.close": "Fermer",
  "lightbox.next": "Suivant",
  "lightbox.previous": "Précédent",
  "lightbox.zoom_in": "Zoomer sur la taille réelle",
  "lightbox.zoom_out": "Zoomer pour adapter",
  "limited_account_hint.action": "Afficher le profil quand même",
  "limited_account_hint.title": "Ce profil ou serveur a été masqué par l'équipe de modération de {domain}.",
  "link_preview.author": "Par {name}",
  "link_preview.more_from_author": "Voir plus de {name}",
  "link_preview.shares": "{count, plural, one {{counter} message} other {{counter} messages}}",
  "lists.add_member": "Ajouter",
  "lists.add_to_list": "Ajouter à la liste",
  "lists.add_to_lists": "Ajouter {name} aux listes",
  "lists.create": "Créer",
  "lists.create_a_list_to_organize": "Créer une nouvelle liste pour organiser votre fil d'actualité",
  "lists.create_list": "Créer une liste",
  "lists.delete": "Supprimer la liste",
  "lists.done": "Terminé",
  "lists.edit": "Modifier la liste",
  "lists.exclusive": "Cacher les membres du fil d'actualité",
  "lists.exclusive_hint": "Si quelqu'un est dans cette liste, les cacher dans votre fil d'actualité pour éviter de voir leurs messages deux fois.",
  "lists.find_users_to_add": "Trouver des utilisateurs à ajouter",
  "lists.list_members_count": "{count, plural, one {# membre} other {# membres}}",
  "lists.list_name": "Nom de la liste",
  "lists.new_list_name": "Nom de la nouvelle liste",
  "lists.no_lists_yet": "Aucune liste pour l'instant.",
  "lists.no_members_yet": "Aucun membre pour l'instant.",
  "lists.no_results_found": "Aucun résultat.",
  "lists.remove_member": "Supprimer",
  "lists.replies_policy.followed": "N'importe quel compte suivi",
  "lists.replies_policy.list": "Membres de la liste",
  "lists.replies_policy.none": "Personne",
  "lists.save": "Enregistrer",
  "lists.search": "Recherche",
  "lists.show_replies_to": "Inclure les réponses des membres de la liste à",
  "load_pending": "{count, plural, one {# nouvel élément} other {# nouveaux éléments}}",
  "loading_indicator.label": "Chargement…",
  "media_gallery.hide": "Masquer",
  "moved_to_account_banner.text": "Votre compte {disabledAccount} est actuellement désactivé parce que vous l'avez déplacé à {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Cacher des notifications",
  "mute_modal.hide_options": "Masquer les options",
  "mute_modal.indefinite": "Jusqu'à ce que je l'affiche à nouveau",
  "mute_modal.show_options": "Afficher les options",
  "mute_modal.they_can_mention_and_follow": "Iel pourra vous mentionner et vous suivre, mais vous ne le verrez pas.",
  "mute_modal.they_wont_know": "Iel ne saura pas qu'iel est masqué·e.",
  "mute_modal.title": "Masquer l'utilisateur·ice ?",
  "mute_modal.you_wont_see_mentions": "Vous ne verrez plus les messages qui le ou la mentionnent.",
  "mute_modal.you_wont_see_posts": "Iel pourra toujours voir vos messages, mais vous ne verrez plus les siens.",
  "navigation_bar.about": "À propos",
  "navigation_bar.account_settings": "Mot de passe et sécurité",
  "navigation_bar.administration": "Administration",
  "navigation_bar.advanced_interface": "Ouvrir dans l’interface avancée",
  "navigation_bar.automated_deletion": "Suppression automatique de messages",
  "navigation_bar.blocks": "Comptes bloqués",
  "navigation_bar.bookmarks": "Marque-pages",
  "navigation_bar.collections": "Collections",
  "navigation_bar.direct": "Mention privée",
  "navigation_bar.domain_blocks": "Domaines bloqués",
  "navigation_bar.favourites": "Favoris",
  "navigation_bar.filters": "Mots masqués",
  "navigation_bar.follow_requests": "Demandes d’abonnement",
  "navigation_bar.followed_tags": "Hashtags suivis",
  "navigation_bar.follows_and_followers": "Abonnements et abonnés",
  "navigation_bar.import_export": "Import et export",
  "navigation_bar.lists": "Listes",
  "navigation_bar.live_feed_local": "Flux en direct (local)",
  "navigation_bar.live_feed_public": "Flux en direct (public)",
  "navigation_bar.logout": "Déconnexion",
  "navigation_bar.main": "Accueil",
  "navigation_bar.moderation": "Modération",
  "navigation_bar.more": "Plus",
  "navigation_bar.mutes": "Comptes masqués",
  "navigation_bar.opened_in_classic_interface": "Les messages, les comptes et les pages spécifiques sont ouvertes dans l’interface classique.",
  "navigation_bar.preferences": "Préférences",
  "navigation_bar.privacy_and_reach": "Vie privée et visibilité",
  "navigation_bar.search": "Rechercher",
  "navigation_bar.search_trends": "Recherche / Tendance",
  "navigation_panel.collapse_followed_tags": "Réduire le menu des hashtags suivis",
  "navigation_panel.collapse_lists": "Réduire le menu de la liste",
  "navigation_panel.expand_followed_tags": "Développer le menu des hashtags suivis",
  "navigation_panel.expand_lists": "Développer le menu de la liste",
  "not_signed_in_indicator.not_signed_in": "Vous devez vous connecter pour accéder à cette ressource.",
  "notification.added_to_collection": "{name} vous a ajouté·e à une collection",
  "notification.admin.report": "{name} a signalé {target}",
  "notification.admin.report_account": "{name} a signalé {count, plural, one {un message} other {# messages}} de {target} pour {category}",
  "notification.admin.report_account_other": "{name} a signalé {count, plural, one {un message} other {# messages}} de {target}",
  "notification.admin.report_statuses": "{name} a signalé {target} pour {category}",
  "notification.admin.report_statuses_other": "{name} a signalé {target}",
  "notification.admin.sign_up": "{name} s'est inscrit·e",
  "notification.admin.sign_up.name_and_others": "{name} et {count, plural, one {# autre} other {# autres}} se sont inscrit",
  "notification.annual_report.message": "Votre {year} #Wrapstodon attend ! Dévoilez les moments forts et mémorables de votre année sur Mastodon !",
  "notification.annual_report.view": "Voir #Wrapstodon",
  "notification.collection_update": "{name} a modifié une collection dans laquelle vous figurez",
  "notification.favourite": "{name} a ajouté votre message à ses favoris",
  "notification.favourite.name_and_others_with_link": "{name} et <a>{count, plural, one {# autre} other {# autres}}</a> ont mis votre message en favori",
  "notification.favourite_pm": "{name} a mis votre mention privée en favori",
  "notification.favourite_pm.name_and_others_with_link": "{name} et <a>{count, plural, one {# autre} other {# autres}}</a> ont mis votre mention privée en favori",
  "notification.follow": "{name} vous suit",
  "notification.follow.name_and_others": "{name} et <a>{count, plural, one {# autre} other {# autres}}</a> vous suivent",
  "notification.follow_request": "{name} a demandé à vous suivre",
  "notification.follow_request.name_and_others": "{name} et {count, plural, one {# autre} other {# autres}} ont demandé à vous suivre",
  "notification.label.mention": "Mention",
  "notification.label.private_mention": "Mention privée",
  "notification.label.private_reply": "Réponse privée",
  "notification.label.quote": "{name} a cité votre message",
  "notification.label.reply": "Réponse",
  "notification.mention": "Mention",
  "notification.mentioned_you": "{name} vous a mentionné·e",
  "notification.moderation-warning.learn_more": "En savoir plus",
  "notification.moderation_warning": "Vous avez reçu un avertissement de modération",
  "notification.moderation_warning.action_delete_statuses": "Certains de vos messages ont été supprimés.",
  "notification.moderation_warning.action_disable": "Votre compte a été désactivé.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Certains de vos messages ont été marqués comme sensibles.",
  "notification.moderation_warning.action_none": "Votre compte a reçu un avertissement de modération.",
  "notification.moderation_warning.action_sensitive": "Vos messages seront désormais marqués comme sensibles.",
  "notification.moderation_warning.action_silence": "Votre compte a été limité.",
  "notification.moderation_warning.action_suspend": "Votre compte a été suspendu.",
  "notification.own_poll": "Votre sondage est terminé",
  "notification.poll": "Un sondage auquel vous avez participé vient de se terminer",
  "notification.quoted_update": "{name} a modifié un message que vous avez cité",
  "notification.reblog": "{name} a partagé votre message",
  "notification.reblog.name_and_others_with_link": "{name} et <a>{count, plural, one {# autre} other {# autres}}</a> ont partagé votre message",
  "notification.relationships_severance_event": "Connexions perdues avec {name}",
  "notification.relationships_severance_event.account_suspension": "Un·e administrateur·rice de {from} a suspendu {target}, ce qui signifie que vous ne pourrez plus recevoir de mises à jour ou interagir avec lui.",
  "notification.relationships_severance_event.domain_block": "Un·e administrateur·rice de {from} en a bloqué {target}, comprenant {followersCount} de vos abonné·e·s et {followingCount, plural, one {# compte} other {# comptes}} vous suivez.",
  "notification.relationships_severance_event.learn_more": "En savoir plus",
  "notification.relationships_severance_event.user_domain_block": "Vous avez bloqué {target}, en supprimant {followersCount} de vos abonnés et {followingCount, plural, one {# compte} other {# comptes}} que vous suivez.",
  "notification.status": "{name} vient de publier",
  "notification.update": "{name} a modifié un message",
  "notification_requests.accept": "Accepter",
  "notification_requests.accept_multiple": "{count, plural, one {Accepter # requête …} other {Accepter # requêtes …}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Accepter la requête} other {Accepter les requêtes}}",
  "notification_requests.confirm_accept_multiple.message": "Vous êtes sur le point d'accepter {count, plural, one {une requête de notification} other {# requêtes de notification}}. Êtes-vous sûr de vouloir continuer ?",
  "notification_requests.confirm_accept_multiple.title": "Accepter les requêtes de notification ?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Ignorer la requête} other {Ignorer les requêtes}}",
  "notification_requests.confirm_dismiss_multiple.message": "Vous êtes sur le point de rejeter {count, plural, one {une requête de notification} other {# requêtes de notification}}. Vous ne pourrez plus {count, plural, one {y} other {y}} accéder facilement plus tard. Voulez-vous vraiment continuer ?",
  "notification_requests.confirm_dismiss_multiple.title": "Rejeter les requêtes de notification ?",
  "notification_requests.dismiss": "Rejeter",
  "notification_requests.dismiss_multiple": "{count, plural, one {Rejeter # requête …} other {Rejeter # requêtes …}}",
  "notification_requests.edit_selection": "Modifier",
  "notification_requests.exit_selection": "Terminé",
  "notification_requests.explainer_for_limited_account": "Les notifications en provenance de ce compte ont été filtrées car le compte a été limité par un modérateur.",
  "notification_requests.explainer_for_limited_remote_account": "Les notifications en provenance de ce compte ont été filtrées car le compte ou le serveur dont il est issu a été limité par un modérateur.",
  "notification_requests.maximize": "Agrandir",
  "notification_requests.minimize_banner": "Réduire la bannière des notifications filtrées",
  "notification_requests.notifications_from": "Notifications de {name}",
  "notification_requests.title": "Notifications filtrées",
  "notification_requests.view": "Afficher les notifications",
  "notifications.clear": "Effacer les notifications",
  "notifications.clear_confirmation": "Voulez-vous vraiment effacer toutes vos notifications ?",
  "notifications.clear_title": "Effacer les notifications ?",
  "notifications.column_settings.admin.report": "Nouveaux signalements :",
  "notifications.column_settings.admin.sign_up": "Nouvelles inscriptions :",
  "notifications.column_settings.alert": "Notifications du navigateur",
  "notifications.column_settings.collections": "Collections :",
  "notifications.column_settings.favourite": "Favoris :",
  "notifications.column_settings.filter_bar.advanced": "Afficher toutes les catégories",
  "notifications.column_settings.filter_bar.category": "Barre de filtre rapide",
  "notifications.column_settings.follow": "Nouveaux·elles abonné·e·s :",
  "notifications.column_settings.follow_request": "Nouvelles demandes d’abonnement :",
  "notifications.column_settings.group": "Grouper",
  "notifications.column_settings.mention": "Mentions :",
  "notifications.column_settings.poll": "Résultats des sondages :",
  "notifications.column_settings.push": "Notifications push",
  "notifications.column_settings.quote": "Citations :",
  "notifications.column_settings.reblog": "Partages :",
  "notifications.column_settings.show": "Afficher dans la colonne",
  "notifications.column_settings.sound": "Jouer un son",
  "notifications.column_settings.status": "Nouveaux messages :",
  "notifications.column_settings.unread_notifications.category": "Notifications non lues",
  "notifications.column_settings.unread_notifications.highlight": "Surligner les notifications non lues",
  "notifications.column_settings.update": "Modifications :",
  "notifications.filter.all": "Tout",
  "notifications.filter.boosts": "Partages",
  "notifications.filter.collections": "Collections",
  "notifications.filter.favourites": "Favoris",
  "notifications.filter.follows": "Abonnés",
  "notifications.filter.mentions": "Mentions",
  "notifications.filter.polls": "Résultats des sondages",
  "notifications.filter.statuses": "Mises à jour des personnes que vous suivez",
  "notifications.grant_permission": "Accorder l’autorisation.",
  "notifications.group": "{count} notifications",
  "notifications.mark_as_read": "Marquer toutes les notifications comme lues",
  "notifications.permission_denied": "Impossible d’activer les notifications de bureau car l’autorisation a été refusée.",
  "notifications.permission_denied_alert": "Les notifications de bureau ne peuvent pas être activées, car l’autorisation du navigateur a été refusée auparavant",
  "notifications.permission_required": "Les notifications de bureau ne sont pas disponibles car l’autorisation requise n’a pas été accordée.",
  "notifications.policy.accept": "Accepter",
  "notifications.policy.accept_hint": "Afficher dans les notifications",
  "notifications.policy.drop": "Ignorer",
  "notifications.policy.drop_hint": "Expulser vers le vide, pour ne plus jamais les revoir",
  "notifications.policy.filter": "Filtrer",
  "notifications.policy.filter_bots_hint": "Comptes marqués comme automatisés",
  "notifications.policy.filter_bots_title": "Bots",
  "notifications.policy.filter_hint": "Envoyer à la boîte de réception des notifications filtrées",
  "notifications.policy.filter_limited_accounts_hint": "Limités par les modérateur·rice·s du serveur",
  "notifications.policy.filter_limited_accounts_title": "Comptes modérés",
  "notifications.policy.filter_new_accounts.hint": "Créés au cours des derniers {days, plural, one {un jour} other {# jours}}",
  "notifications.policy.filter_new_accounts_title": "Nouveaux comptes",
  "notifications.policy.filter_not_followers_hint": "Incluant les personnes qui vous suivent depuis moins de {days, plural, one {un jour} other {# jours}}",
  "notifications.policy.filter_not_followers_title": "Personnes qui ne vous suivent pas",
  "notifications.policy.filter_not_following_hint": "Jusqu'à ce que vous les validiez manuellement",
  "notifications.policy.filter_not_following_title": "Personnes que vous ne suivez pas",
  "notifications.policy.filter_private_mentions_hint": "Filtrées sauf si c'est en réponse à l'une de vos mentions ou si vous suivez la personne",
  "notifications.policy.filter_private_mentions_title": "Mentions privées non sollicitées",
  "notifications.policy.title": "Gestion des notifications des…",
  "notifications_permission_banner.enable": "Activer les notifications de bureau",
  "notifications_permission_banner.how_to_control": "Pour recevoir des notifications lorsque Mastodon n’est pas ouvert, activez les notifications du bureau. Vous pouvez contrôler précisément quels types d’interactions génèrent des notifications de bureau via le bouton {icon} ci-dessus une fois qu’elles sont activées.",
  "notifications_permission_banner.title": "Toujours au courant",
  "onboarding.follows.back": "Retour",
  "onboarding.follows.empty": "Malheureusement, aucun résultat ne peut être affiché pour le moment. Vous pouvez essayer d'utiliser la recherche ou parcourir la page de découverte pour trouver des personnes à suivre, ou réessayez plus tard.",
  "onboarding.follows.next": "Suivant : configurer votre profil",
  "onboarding.follows.search": "Recherche",
  "onboarding.follows.title": "Suivre des personnes pour commencer",
  "onboarding.profile.discoverable": "Permettre de découvrir mon profil",
  "onboarding.profile.discoverable_hint": "Lorsque vous acceptez d'être découvert sur Mastodon, vos messages peuvent apparaître dans les résultats de recherche et les tendances, et votre profil peut être suggéré à des personnes ayant des intérêts similaires aux vôtres.",
  "onboarding.profile.display_name": "Nom affiché",
  "onboarding.profile.display_name_hint": "Votre nom complet ou votre nom rigolo…",
  "onboarding.profile.finish": "Terminer",
  "onboarding.profile.note": "Biographie",
  "onboarding.profile.note_hint": "Vous pouvez @mentionner d'autres personnes ou #hashtags…",
  "onboarding.profile.title": "Configuration du profil",
  "onboarding.profile.upload_avatar": "Importer une photo de profil",
  "onboarding.profile.upload_header": "Importer une image de couverture",
  "password_confirmation.exceeds_maxlength": "La confirmation du mot de passe dépasse la longueur du mot de passe",
  "password_confirmation.mismatching": "Les deux mots de passe ne correspondent pas",
  "picture_in_picture.restore": "Remettre en place",
  "poll.closed": "Fermé",
  "poll.refresh": "Actualiser",
  "poll.reveal": "Voir les résultats",
  "poll.total_people": "{count, plural, one {# personne} other {# personnes}}",
  "poll.total_votes": "{count, plural, one {# vote} other {# votes}}",
  "poll.vote": "Voter",
  "poll.voted": "Vous avez voté pour cette réponse",
  "poll.votes": "{votes, plural, one {# vote} other {# votes}}",
  "poll_button.add_poll": "Ajouter un sondage",
  "poll_button.remove_poll": "Supprimer le sondage",
  "privacy.change": "Ajuster la confidentialité du message",
  "privacy.direct.long": "Seulement les personnes mentionnées dans le message",
  "privacy.direct.short": "Mention privée",
  "privacy.private.long": "Seulement vos abonnés",
  "privacy.private.short": "Abonnés",
  "privacy.public.long": "Tout le monde sur et en dehors de Mastodon",
  "privacy.public.short": "Public",
  "privacy.quote.anyone": "{visibility}, citations autorisées",
  "privacy.quote.disabled": "{visibility}, citations désactivées",
  "privacy.quote.limited": "{visibility}, citations limitées",
  "privacy.unlisted.additional": "Se comporte exactement comme « public », sauf que le message n'apparaîtra pas dans les flux en direct, les hashtags, explorer ou la recherche Mastodon, même si vous les avez activé au niveau de votre compte.",
  "privacy.unlisted.long": "Caché des résultats de recherche de Mastodon, des tendances et des fils publics",
  "privacy.unlisted.short": "Public discret",
  "privacy_policy.last_updated": "Dernière mise à jour {date}",
  "privacy_policy.title": "Politique de confidentialité",
  "quote_error.edit": "Les citations ne peuvent pas être ajoutés lors de l'édition d'un message.",
  "quote_error.poll": "Les citations ne sont pas autorisées avec les sondages.",
  "quote_error.private_mentions": "La citation n'est pas autorisée avec les mentions privées.",
  "quote_error.quote": "Une seule citation à la fois est autorisée.",
  "quote_error.unauthorized": "Vous n'êtes pas autorisé⋅e à citer ce message.",
  "quote_error.upload": "La citation n'est pas autorisée avec un média joint.",
  "recommended": "Recommandé",
  "refresh": "Actualiser",
  "regeneration_indicator.please_stand_by": "Veuillez patienter.",
  "regeneration_indicator.preparing_your_home_feed": "Préparation de votre flux principal…",
  "relative_time.days": "{number} j",
  "relative_time.full.days": "il y a {number, plural, one {# jour} other {# jours}}",
  "relative_time.full.hours": "il y a {number, plural, one {# heure} other {# heures}}",
  "relative_time.full.just_now": "à l’instant",
  "relative_time.full.minutes": "il y a {number, plural, one {# minute} other {# minutes}}",
  "relative_time.full.seconds": "il y a {number, plural, one {# second} other {# seconds}}",
  "relative_time.hours": "{number} h",
  "relative_time.just_now": "à l’instant",
  "relative_time.minutes": "{number} min",
  "relative_time.seconds": "{number} s",
  "relative_time.today": "aujourd’hui",
  "remove_quote_hint.button_label": "Compris",
  "remove_quote_hint.message": "Vous pouvez le faire à partir du menu des options {icon}.",
  "remove_quote_hint.title": "Vous voulez supprimer votre message cité ?",
  "reply_indicator.attachments": "{count, plural, one {# pièce jointe} other {# pièces jointes}}",
  "reply_indicator.cancel": "Annuler",
  "reply_indicator.poll": "Sondage",
  "report.block": "Bloquer",
  "report.block_explanation": "Vous ne verrez plus les messages de ce profil, et il ne pourra ni vous suivre ni voir vos messages. Il pourra savoir qu'il a été bloqué.",
  "report.categories.legal": "Légal",
  "report.categories.other": "Autre",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Le contenu enfreint une ou plusieurs règles du serveur",
  "report.category.subtitle": "Sélctionnez ce qui correspond le mieux",
  "report.category.title_account": "Dites-nous ce qu'il se passe avec ce profil",
  "report.category.title_collection": "Dites-nous ce qu'il se passe avec cette collection",
  "report.category.title_status": "Dites-nous ce qu'il se passe avec ce message",
  "report.close": "Terminé",
  "report.comment.title": "Y a-t-il autre chose que nous devrions savoir ?",
  "report.forward": "Transférer à {target}",
  "report.forward_hint": "Le compte provient d’un autre serveur. Envoyer également une copie anonyme du rapport ?",
  "report.mute": "Masquer",
  "report.mute_explanation": "Vous ne verrez plus les messages de ce compte, mais il pourra toujours vous suivre et voir vos messages. Il ne pourra pas savoir qu'il a été masqué.",
  "report.next": "Suivant",
  "report.placeholder": "Commentaires additionnels",
  "report.reasons.dislike": "Cela ne me plaît pas",
  "report.reasons.dislike_description": "Ce n'est pas quelque chose que vous voulez voir",
  "report.reasons.legal": "C'est illégal",
  "report.reasons.legal_description": "Vous pensez que cela viole la loi de votre pays ou de celui du serveur",
  "report.reasons.other": "Pour une autre raison",
  "report.reasons.other_description": "Le problème ne correspond pas aux autres catégories",
  "report.reasons.spam": "C'est du spam",
  "report.reasons.spam_description": "Liens malveillants, faux engagement ou réponses répétitives",
  "report.reasons.violation": "Infraction des règles du serveur",
  "report.reasons.violation_description": "Vous savez que des règles précises sont enfreintes",
  "report.rules.subtitle": "Sélectionnez toutes les réponses appropriées",
  "report.rules.title": "Quelles règles sont enfreintes ?",
  "report.statuses.subtitle": "Sélectionnez toutes les réponses appropriées",
  "report.statuses.title": "Existe-t-il des messages pour étayer ce rapport ?",
  "report.submission_error": "Le signalement n’a pas pu être envoyé",
  "report.submission_error_details": "Veuillez vérifier votre connexion réseau et réessayer plus tard.",
  "report.submit": "Envoyer",
  "report.target": "Signalement de {target}",
  "report.thanks.take_action": "Voici les possibilités que vous avez pour contrôler ce que vous voyez sur Mastodon :",
  "report.thanks.take_action_actionable": "Pendant que nous étudions votre requête, vous pouvez prendre des mesures contre @{name} :",
  "report.thanks.title": "Vous ne voulez pas voir cela ?",
  "report.thanks.title_actionable": "Merci pour votre signalement, nous allons investiguer.",
  "report.unfollow": "Ne plus suivre @{name}",
  "report.unfollow_explanation": "Vous êtes abonné à ce compte. Pour ne plus voir ses messages dans votre fil principal, retirez-le de votre liste d'abonnements.",
  "report_notification.attached_statuses": "{count, plural, one {{count} message joint} other {{count} messages joints}}",
  "report_notification.categories.legal": "Légal",
  "report_notification.categories.legal_sentence": "contenu illégal",
  "report_notification.categories.other": "Autre",
  "report_notification.categories.other_sentence": "autre",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "indésirable",
  "report_notification.categories.violation": "Infraction aux règles du serveur",
  "report_notification.categories.violation_sentence": "infraction de règle",
  "report_notification.open": "Ouvrir le signalement",
  "search.clear": "Effacer la recherche",
  "search.no_recent_searches": "Aucune recherche récente",
  "search.placeholder": "Rechercher",
  "search.quick_action.account_search": "Profils correspondant à {x}",
  "search.quick_action.go_to_account": "Aller au profil {x}",
  "search.quick_action.go_to_hashtag": "Aller au hashtag {x}",
  "search.quick_action.open_url": "Ouvrir l'URL dans Mastodon",
  "search.quick_action.status_search": "Messages correspondant à {x}",
  "search.search_or_paste": "Rechercher ou saisir une URL",
  "search_popout.full_text_search_disabled_message": "Non disponible sur {domain}.",
  "search_popout.full_text_search_logged_out_message": "Disponible uniquement lorsque vous êtes connecté.",
  "search_popout.language_code": "code de langue ISO",
  "search_popout.options": "Options de recherche",
  "search_popout.quick_actions": "Actions rapides",
  "search_popout.recent": "Recherches récentes",
  "search_popout.specific_date": "date spécifique",
  "search_popout.user": "utilisateur·ice",
  "search_results.accounts": "Profils",
  "search_results.all": "Tous les résultats",
  "search_results.collections": "Collections",
  "search_results.hashtags": "Hashtags",
  "search_results.no_results": "Aucun résultat.",
  "search_results.no_search_yet": "Essayez de rechercher des messages, des profils ou des hashtags.",
  "search_results.see_all": "Afficher tout",
  "search_results.statuses": "Messages",
  "search_results.title": "Résultats pour « {q} »",
  "server_banner.about_active_users": "Personnes utilisant ce serveur au cours des 30 derniers jours (Comptes actifs mensuellement)",
  "server_banner.active_users": "comptes actifs",
  "server_banner.administered_by": "Administré par :",
  "server_banner.is_one_of_many": "{domain} est l'un des nombreux serveurs Mastodon indépendants que vous pouvez utiliser pour participer au fédivers.",
  "server_banner.more_about_this_server": "En savoir plus sur ce serveur",
  "server_banner.server_stats": "Statistiques du serveur :",
  "sign_in_banner.create_account": "Créer un compte",
  "sign_in_banner.follow_anyone": "Suivez n'importe qui à travers le fédivers et affichez tout dans un ordre chronologique. Ni algorithmes, ni publicités, ni appâts à clics en perspective.",
  "sign_in_banner.mastodon_is": "Mastodon est le meilleur moyen de suivre ce qui se passe.",
  "sign_in_banner.sign_in": "Se connecter",
  "sign_in_banner.sso_redirect": "Se connecter ou s’inscrire",
  "skip_links.hotkey": "<span>Raccourci</span> {hotkey}",
  "skip_links.skip_to_content": "Accéder au contenu principal",
  "skip_links.skip_to_navigation": "Accéder à la navigation principale",
  "status.admin_account": "Ouvrir l’interface de modération pour @{name}",
  "status.admin_domain": "Ouvrir l’interface de modération pour {domain}",
  "status.admin_status": "Ouvrir ce message dans l’interface de modération",
  "status.all_disabled": "Les partages et citations sont désactivés",
  "status.block": "Bloquer @{name}",
  "status.bookmark": "Ajouter aux marque-pages",
  "status.cancel_reblog_private": "Annuler le partage",
  "status.cannot_edit": "Vous n'êtes pas autorisé à modifier ce message",
  "status.cannot_quote": "Vous n'êtes pas autorisé à citer ce message",
  "status.cannot_reblog": "Ce message ne peut pas être partagé",
  "status.contains_quote": "Contient une citation",
  "status.context.loading": "Chargement de réponses supplémentaires",
  "status.context.loading_error": "Impossible de charger les nouvelles réponses",
  "status.context.loading_success": "De nouvelles réponses ont été chargées",
  "status.context.more_replies_found": "Plus de réponses trouvées",
  "status.context.retry": "Réessayer",
  "status.context.show": "Afficher",
  "status.continued_thread": "Suite du fil",
  "status.copy": "Copier le lien vers le message",
  "status.delete": "Supprimer",
  "status.delete.success": "Message supprimé",
  "status.detailed_status": "Vue détaillée de la conversation",
  "status.direct": "Mentionner @{name} en privé",
  "status.direct_indicator": "Mention privée",
  "status.edit": "Modifier",
  "status.edited": "Dernière modification le {date}",
  "status.edited_x_times": "Modifié {count, plural, one {{count} fois} other {{count} fois}}",
  "status.embed": "Obtenir le code d'intégration",
  "status.favourite": "Ajouter aux favoris",
  "status.favourites_count": "{count, plural, one {{counter} favori} other {{counter} favoris}}",
  "status.filter": "Filtrer ce message",
  "status.history.created": "Créé par {name} {date}",
  "status.history.edited": "Modifié par {name} {date}",
  "status.load_more": "Charger plus",
  "status.media.open": "Cliquer pour ouvrir",
  "status.media.show": "Cliquer pour afficher",
  "status.media_hidden": "Média caché",
  "status.mention": "Mentionner @{name}",
  "status.more": "Plus",
  "status.mute": "Masquer @{name}",
  "status.mute_conversation": "Masquer la conversation",
  "status.not_quoted": "Vous n'êtes pas cité dans ce message",
  "status.open": "Développer ce message",
  "status.pin": "Épingler sur le profil",
  "status.public_only": "Ce message est privé",
  "status.quote": "Citer",
  "status.quote.cancel": "Annuler la citation",
  "status.quote_error.blocked_account_hint.title": "Ce message est masqué car vous avez bloqué @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Ce message est masqué car vous avez bloqué {domain}.",
  "status.quote_error.filtered": "Caché par un de vos filtres",
  "status.quote_error.limited_account_hint.action": "Afficher quand même",
  "status.quote_error.limited_account_hint.title": "Ce compte a été masqué par la modération de {domain}.",
  "status.quote_error.muted_account_hint.title": "Ce message est caché car vous avez masqué @{name}.",
  "status.quote_error.not_available": "Message indisponible",
  "status.quote_error.pending_approval": "Message en attente",
  "status.quote_error.pending_approval_popout.body": "Sur Mastodon, vous pouvez contrôler si quelqu'un peut vous citer. Ce message est en attente pendant que nous recevons l'approbation de l'auteur original.",
  "status.quote_error.revoked": "Message supprimé par l'auteur·rice",
  "status.quote_followers_only": "Seul·e·s les abonné·e·s peuvent citer ce message",
  "status.quote_manual_review": "L'auteur·rice approuvera manuellement",
  "status.quote_noun": "Citation",
  "status.quote_policy_change": "Changer qui peut vous citer",
  "status.quote_post_author": "A cité un message de @{name}",
  "status.quote_private": "Les messages privés ne peuvent pas être cités",
  "status.quotes.empty": "Personne n'a encore cité ce message. Quand quelqu'un le fera, la citation apparaîtra ici.",
  "status.quotes.local_other_disclaimer": "Les citations rejetées par l'auteur·rice ne seront pas affichées.",
  "status.quotes.remote_other_disclaimer": "Seules les citations de {domain} sont garanties d'être affichées ici. Les citations rejetées par l'auteur·rice ne seront pas affichées.",
  "status.quotes_count": "{count, plural, one {{counter} citation} other {{counter} citations}}",
  "status.read_more": "Lire la suite",
  "status.reblog": "Partager",
  "status.reblog_or_quote": "Partager ou citer",
  "status.reblog_private": "Partager à nouveau avec vos abonné·e·s",
  "status.reblogged_by": "{name} a partagé",
  "status.reblogs.empty": "Personne n’a encore partagé ce message. Lorsque quelqu’un le fera, il apparaîtra ici.",
  "status.reblogs_count": "{count, plural, one {{counter} partage} other {{counter} partages}}",
  "status.redraft": "Supprimer et réécrire",
  "status.remove_bookmark": "Retirer des marque-pages",
  "status.remove_favourite": "Retirer des favoris",
  "status.remove_quote": "Supprimer",
  "status.replied_in_thread": "A répondu dans un fil de discussion",
  "status.replied_to": "En réponse à {name}",
  "status.reply": "Répondre",
  "status.replyAll": "Répondre au fil",
  "status.report": "Signaler @{name}",
  "status.request_quote": "Demander à citer",
  "status.revoke_quote": "Retirer mon message du post de @{name}",
  "status.sensitive_warning": "Contenu sensible",
  "status.share": "Partager",
  "status.show_less_all": "Tout replier",
  "status.show_more_all": "Tout déplier",
  "status.show_original": "Afficher l’original",
  "status.title.with_attachments": "{user} a publié {attachmentCount, plural, one {une pièce jointe} other {{attachmentCount} pièces jointes}}",
  "status.translate": "Traduire",
  "status.translated_from_with": "Traduit de {lang} en utilisant {provider}",
  "status.uncached_media_warning": "Prévisualisation non disponible",
  "status.unmute_conversation": "Ne plus masquer la conversation",
  "status.unpin": "Retirer du profil",
  "subscribed_languages.lead": "Seuls les messages dans les langues sélectionnées apparaîtront sur votre fil principal et vos listes de fils après le changement. Sélectionnez aucune pour recevoir les messages dans toutes les langues.",
  "subscribed_languages.save": "Enregistrer les modifications",
  "subscribed_languages.target": "Modifier les langues d'abonnements pour {target}",
  "tabs_bar.home": "Accueil",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Notifications",
  "tabs_bar.publish": "Nouveau message",
  "tabs_bar.quick_links": "Accès rapides",
  "tabs_bar.search": "Chercher",
  "tag.remove": "Supprimer",
  "terms_of_service.effective_as_of": "En vigueur à compter du {date}",
  "terms_of_service.title": "Conditions d'utilisation",
  "terms_of_service.upcoming_changes_on": "Modifications à venir le {date}",
  "time_remaining.days": "{number, plural, one {# jour restant} other {# jours restants}}",
  "time_remaining.hours": "{number, plural, one {# heure restante} other {# heures restantes}}",
  "time_remaining.minutes": "{number, plural, one {# minute restante} other {# minutes restantes}}",
  "time_remaining.moments": "Encore quelques instants",
  "time_remaining.seconds": "{number, plural, one {# seconde restante} other {# secondes restantes}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} pers.} other {{counter} pers.}} sur {days, plural, one {les dernières 24h} other {les {days} derniers jours}}",
  "trends.trending_now": "Tendance en ce moment",
  "ui.beforeunload": "Votre brouillon sera perdu si vous quittez Mastodon.",
  "units.short.billion": "{count}Md",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Glissez et déposez pour envoyer",
  "upload_button.label": "Ajouter des images, une vidéo ou un fichier audio",
  "upload_error.limit": "Taille maximale d'envoi de fichier dépassée.",
  "upload_error.poll": "L’envoi de fichiers n’est pas autorisé avec les sondages.",
  "upload_error.quote": "L’envoi de fichiers n’est pas autorisé avec les citations.",
  "upload_form.drag_and_drop.instructions": "Pour choisir un média joint, appuyez sur la touche espace ou entrée. Pour glisser, utilisez les touches fléchées pour déplacer le fichier média dans une direction donnée. Appuyez à nouveau sur la touche espace ou entrée pour déposer le fichier média dans sa nouvelle position, ou appuyez sur la touche Echap pour annuler.",
  "upload_form.drag_and_drop.on_drag_cancel": "Déplacement annulé. La pièce jointe {item} n'a pas été ajoutée.",
  "upload_form.drag_and_drop.on_drag_end": "La pièce jointe du média {item} a été déposée.",
  "upload_form.drag_and_drop.on_drag_over": "La pièce jointe du média {item} a été déplacée.",
  "upload_form.drag_and_drop.on_drag_start": "Sélection de la pièce jointe {item}.",
  "upload_form.edit": "Modifier",
  "upload_progress.label": "Envoi en cours…",
  "upload_progress.processing": "En cours…",
  "username.taken": "Ce nom d'utilisateur est déjà pris. Essayez d'en prendre un autre",
  "video.close": "Fermer la vidéo",
  "video.download": "Télécharger le fichier",
  "video.exit_fullscreen": "Quitter le plein écran",
  "video.expand": "Agrandir la vidéo",
  "video.fullscreen": "Plein écran",
  "video.hide": "Masquer la vidéo",
  "video.mute": "Couper le son",
  "video.pause": "Pause",
  "video.play": "Lecture",
  "video.skip_backward": "Revenir en arrière",
  "video.skip_forward": "Avancer",
  "video.unmute": "Rétablir le son",
  "video.volume_down": "Baisser le volume",
  "video.volume_up": "Augmenter le volume",
  "visibility_modal.button_title": "Définir la visibilité",
  "visibility_modal.direct_quote_warning.text": "Si vous enregistrez les paramètres actuels, la citation sera convertie en lien.",
  "visibility_modal.direct_quote_warning.title": "Les citations ne peuvent pas être intégrées dans les mentions privées",
  "visibility_modal.header": "Visibilité et interactions",
  "visibility_modal.helper.direct_quoting": "Les mentions privées rédigées sur Mastodon ne peuvent pas être citées par d'autres personnes.",
  "visibility_modal.helper.privacy_editing": "La visibilité ne peut pas être modifiée après la publication d'un message.",
  "visibility_modal.helper.privacy_private_self_quote": "Les auto-citations de messages privés ne peuvent pas être rendues publiques.",
  "visibility_modal.helper.private_quoting": "Les messages accessibles uniquement aux abonné·es publiés sur Mastodon ne peuvent être cités par d'autres personnes.",
  "visibility_modal.helper.unlisted_quoting": "Lorsque les gens vous citent, leur message sera également caché des fils tendances.",
  "visibility_modal.instructions": "Contrôlez qui peut interagir avec ce message. Vous pouvez également appliquer ces paramètres à tous les futurs messages en allant dans <link>Préférences > Paramètres de publication par défaut</link>.",
  "visibility_modal.privacy_label": "Visibilité",
  "visibility_modal.quote_followers": "Abonné·e·s seulement",
  "visibility_modal.quote_label": "Autoriser les citations pour",
  "visibility_modal.quote_nobody": "Juste moi",
  "visibility_modal.quote_public": "Tout le monde",
  "visibility_modal.save": "Sauvegarder"
}
